export default () => {
  var brands = {
    CB: {
      bankName: 'Clydesdale',
      bankCode: 'CB',
      bankWebsite: 'http://www.cbonline.co.uk',
      phoneNumber: '0800 028 3632',
      appendBank: true,
      faqsLink:
        'https://secure.cbonline.co.uk/help-support/current-account-help/',
      monetiseLink:
        'http://www.cbonline.co.uk/personal/current-accounts/nextsteps/',
    },
    DYB: {
      bankName: 'B',
      bankCode: 'B',
      bankWebsite: 'http://www.cbonline.co.uk',
      phoneNumber: '0800 121 7365',
      appendBank: true,
    },
    YB: {
      bankName: 'Yorkshire',
      bankCode: 'YB',
      bankWebsite: 'http://www.ybonline.co.uk',
      phoneNumber: '0800 028 3632',
      appendBank: false,
      faqsLink:
        'https://secure.ybonline.co.uk/help-support/current-account-help/',
      monetiseLink:
        'http://www.ybonline.co.uk/personal/current-accounts/nextsteps/',
    },
  };

  var appLinks = {
    ios: {
      link: 'http://itunes.apple.com/app/id1051351437',
      title: 'App Store',
    },
    android: {
      link: 'https://play.google.com/store/apps/details?id=co.uk.youandb.android.b',
      title: 'Google Play',
    },
    amazon: {
      link: 'http://www.amazon.co.uk/gp/mas/dl/android?p=co.uk.youandb.android.b',
      title: 'Amazon App Store',
    },
  };

  var brand = brands.DYB;

  var result = {
    bankNames: {
      CB: brands.CB.bankName,
      YB: brands.YB.bankName,
      DYB: brands.DYB.bankName,
    },
    appLinks: appLinks,
    bankWebsite: brand.bankWebsite,
    typeLabel: 'Type',
    fromLabel: 'From',
    toLabel: 'To',
    debitAmountLabel: 'Debit amount',
    paymentFeesLabel: 'Payment fees',
    submissionDateLabel: 'Payment submission date',
    exchangeRateLabel: 'Exchange rate',
    actualRateLabel: 'Actual exchange rate',
    sendAmountLabel: 'Send amount',
    settlementDateLabel: 'Earliest estimated settlement date',
    referenceLabel: 'Reason for payment',
    createdByLabel: 'Created by',
    createdOnLabel: 'Created on',
    authorisedByLabel: 'Authorised by',
    feesLabel: 'Fees',
    paymentDateLabel: 'Payment date',
    bacsID: 'BACS Id',
    transactionCodeLabel: 'Transaction Code',
    hmrcReferenceLabel: 'HMRC Reference',
    referencePaymentLabel: 'Reference',
    settlementPaymentDateLabel: 'Settlement Date',

    // MasterCardAlerts
    masterCardPopupWarningHeader: 'Your changes haven’t been made yet',
    masterCardPopupWarningBody:
      'If you leave now, your changes won’t be made and your alerts won’t be updated.',
    masterCardLeavePageBtn: 'Cancel changes',
    masterCardContinuePageBtn: 'Review and confirm changes',

    // Product Links
    productLinkIM540: brand.bankWebsite + '/personal/current-accounts/direct/',
    productLinkIM135:
      brand.bankWebsite + '/personal/current-accounts/current-account-plus/',
    productLinkIM125:
      brand.bankWebsite + '/personal/current-accounts/current-account-control/',
    productLinkIM800:
      brand.bankWebsite +
      '/personal/current-accounts/standard-current-account/',
    productLinkIM136: 'http://www.youandb.co.uk/getb',

    // Document
    documentTitle: brand.bankCode + ' Web',
    navigationWarning:
      "If you refresh or leave this page, you'll lose any unsaved progress. Are you sure you want to leave?",

    // Header Logo
    headerLogoAlt: brand.bankName + ' Bank Logo',

    // Side Progress Bar
    sidebarStep1: 'About you',
    sidebarStep2: 'Your money',
    sidebarStep3: 'All systems go',

    exportTransaction: 'Download transactions',
    paperStatement: 'Order a paper statement',
    chequeBook: 'Order a new cheque book',
    payBook: 'Order a new pay-in book',
    // inline error messages for move money
    nameErrorMessage: 'Enter their name then try again.',
    inlineErrorDangerClass: 'c-field__message alert alert-danger',
    personCompanyErrorMessage:
      'Enter the name of the person or company you want to pay then try again.',
    referenceErrorMessage: 'Enter a reference for this payment then try again.',
    accountHolderErrorMessage:
      'Enter the name of the person who holds this account.',
    sortCodeErrorMessage: 'Enter their six-digit sort code then try again.',
    accountNumberErrorMessage:
      'Enter their eight-digit account number then try again.',
    nicknameErrorMessage:
      'Enter a nickname for the person or company you want to pay then try again.',
    dateErrorMesaage:
      'Choose the date you want to make repeating payment. This should be entered as DD/MM/YYYY.',

    reviewHeaderMsg:
      'Check the details you have entered are right before you make your payment.',

    paymentType: 'Payment type',
    balanceMsg: 'Balance after payment',

    noOfPayments: 'payments',
    noOfPayment: 'payment',

    noOfTimesEdgeCaseMessage:
      'Oops, that’s too many payments. Enter 300 or less then try again.',
    howOftenErrorMessage: 'Please select one of the options.',
    referenceFieldMsgMoveMoneyTransfer:
      'Add a brief description to remind you why you moved this money. This will appear in your transactions and statements.',

    // company button name
    companyButtonName: 'Add new payment details',
    makePaymentBtn: 'Make a payment to this payee',
    goAcctBtn: 'Go to Accounts',
    goMangePayeeBtn: 'Manage your payees',
    companyAddedMsg1:
      ' has now been added to your list of people and companies you pay.',
    companyAddedMsg2: 'list of people and companies you pay.',

    quikLinkMsg: 'Manage who you pay',
    payeeHeader: 'Pay someone new',
    summaryHeaderTitle: 'New payee added',
    subHeader: 'Who would you like to pay?',
    referenceFieldMsgMoveMoney:
      'Add a brief description of what the payment’s for, like ‘holiday’ or ‘dinner’. Paying a business or organisation? Enter the reference they’ve given you on your bill or invoice.',
    reviewHeaderTitleMoveMoney: 'Review your payment',
    softTokenAlternativeHeaderTitleMoveMoney: 'Give this payment the OK',
    softTokenAlternativeHeaderMsg:
      'To continue with this payment, you have to authorise it using your Security token.',

    noOfTimesMsg:
      'Enter the number of payments you want to make before this repeating payment stops.',

    editpayeeSumamaryMsg: 'All done. You’re good to go.',
    editPayeeWarningPopup1:
      'The changes you’ve just made will only apply to new payments you make to this person or company in the future. If you’re already paying them by Direct Debit or standing order, you’ll need to update those details too.',
    editPayeeWarningPopup2:
      'You can update a standing order online but if you want to change a Direct Debit, you’ll have to get in touch with the company you’re paying to make the changes for you.',

    deletePopupHeading: 'Sure you want to delete them?',
    deletePayeePopUp1:
      'You’re about to delete the following person or company. This won’t affect any scheduled payments you’ve got set up for them.',
    deletePayeePopUp2:
      'If you want to cancel a scheduled payment, like a Direct Debit or standing order, go ahead and ',
    deletePayeePopUp3: 'manage your scheduled payments',
    deletePopupBtn: 'Delete',
    payeePoupDeleted:
      ' has now been deleted from your list of people and companies you pay.',

    viewPaymentHeader: 'Manage your scheduled payments',

    emptyDDListMsg: "You don't have any scheduled payments.",
    emptySOListMsg: "You don't have any scheduled payments.",
    emptyOtherListMsg: "You don't have any scheduled payments.",

    footerDDListMsg: 'Any new scheduled payments you set up will appear here.',
    footerSOListMsg: 'Any new scheduled payments you set up will appear here.',
    footerOtherListMsg:
      'Any new scheduled payments you set up will appear here.',

    activeFooter:
      "That's all of them. Any new scheduled payments you set up will appear here.",

    alternativeText: ' enter their sort code and account number',
    alternativeCompanyText: " search using the company's name",

    siteHeaderModalTitle: "Your {paymentType} hasn't been made yet",

    referenceNumberTextAddPayee:
      'They’ll see this. You can add customer references, credit card or roll numbers here (if you have them).',

    addPayeeBTn: 'Add new payment details',
    reviewSOMsg:
      '<strong> {oftenText} </strong> starting from <strong> {startDate} </strong> and stopping <strong> {endDateLabel} </strong>',
    reviewSOMsg1:
      '<strong> {oftenText} </strong> starting from <strong> {startDate} </strong> and stopping <strong> on {endDateLabel} </strong>',

    managePageheaderTitle: 'Manage who you pay',
    editPageheaderTitle: 'Edit details',

    limitLink: 'How much can I move?',
    apply: '',
    amountEdgeCaseErrorMessage:
      'Sorry, you’re not allowed to move that much online in one transaction. You can see how much you can move in the FAQs.',
    // Key Features
    noMonthlyFee: 'There is no monthly fee for this account.',
    noMonthlyFeeOrCharges: 'There are no fees or charges for this account.',
    monthlyFee:
      'A Monthly Maintenance Fee of £2 applies to the B banking service and will be applied following a 12 month free period. Full details can be found in your Terms & Conditions and Tariff.',
    variableCreditInterest:
      'Variable credit interest is payable on this account on credit balances.',
    noCreditInterest: "This account doesn't pay credit interest.",
    interestUpTo3000:
      'Interest is payable on this account on credit balances up to £3000.',
    noUnplannedBorrowing:
      'Borrowing is not available on this account. Requests for unplanned borrowing will usually be declined. An item returned unpaid costs £15. Full details can be found in the Borrowing section of your Terms & Conditions and in your Tariff.',
    plannedBorrowing125:
      'Planned borrowing is available on this account, subject to eligibility. The cost of this is £6 per month plus interest. Requests for unplanned borrowing will usually be declined. Full details can be found in the Borrowing section of your Terms & Conditions and in your Tariff.',
    plannedBorrowing:
      'Borrowing is available on this account, subject to eligibility, and is usually more expensive if not agreed in advance. Planned borrowing costs £6 per month plus interest. Unplanned borrowing costs £6 per day. An item returned unpaid costs £15. Full details can be found in the Borrowing section of your Terms & Conditions and in your Tariff.',
    fscsCovered:
      'Your eligible deposits with Clydesdale Bank PLC are protected up to a total of £75,000 by the Financial Services Compensation Scheme, the UK\'s deposit guarantee scheme. This limit is applied to the total of any deposits you have with Clydesdale Bank, Yorkshire Bank and B. Any total deposits you hold above the limit between these brands are unlikely to be covered. Please see <a href="http://www.cbonline.co.uk/resources/b82e172a-b00f-4783-973b-e4399da349e4/fscs_2015_online-leaflet.pdf" target="_blank" title="www.fscs.org.uk. This link will open in a new browser window">FSCS leaflet<span class="screenreader"> This link will open in a new browser window</span></a> for further information or visit <a href="http://www.fscs.org.uk" target="_blank" title="www.fscs.org.uk. This link will open in a new browser window">www.fscs.org.uk<span class="screenreader"> This link will open in a new browser window</span></a>',
    defaultCancellationPolicy:
      'You can cancel your agreement with us within 14 days of opening the account, or from the day you receive the Terms & Conditions, if later, by contacting us in branch, by phone or in writing.  You will need to repay any debit balance, interest and fees incurred within 30 days of the date you tell us you want to cancel it.',
    mortgageSaver:
      'Both B Current and B Instant Savings accounts are eligible for inclusion in mortgage offsetting arrangements. Any credit balance can be used to set against the debit balance on your Offset Mortgage held with us and so reduce the interest payable on your mortgage. Full details can be found in the Offsetting section of your Terms & Conditions',
    accountClosureInfo:
      "If you close all of your B Current accounts, you'll no longer have access to the B app (unless you hold another account that the team at B agree can be used to access the app) and your B Instant Savings accounts will be closed or transferred to another instant savings account.",
    caDirectKeyFeature:
      'This account requires a minimum deposit of £1000 per month (excluding transfers from other accounts held with us), and that you must register for telephone and internet services and use these for day-to-day banking. Please note, if you fail to meet these criteria, we may change your account to a Current Account Plus which has different interest rates.',
    caDirectKeyFeature2:
      'You can have a maximum of 2 Current Account Direct accounts, of which only one may be a sole account.',

    // Key Features B
    keyFeatureRequirements:
      'You are applying for both a B Current account and a B Instant Savings account. Both are required to take full advantage of all the features of B.',
    keyFeatureRequirementsB:
      'You will need both a compatible tablet and compatible mobile phone to access the full range of services available in the B app, though other mobile phones can still be used to receive SMS alerts',
    keyFeatureCreditIterest:
      'Credit interest is payable on both the current and the savings account; please refer to your Tariff for rates.',
    keyFeatureTransfer:
      'If you want to take money out of your B Instant Savings account, you need to transfer the money into your B Current account first and make your payment from there. You will be able to make transfers from your B Instant Savings account to some other accounts you hold with us',
    keyFeatureNoDirectDebitSavings:
      'No standing orders or Direct Debits can be set up on your B Instant Savings account',
    keyFeaturesComplaints:
      'We are committed to providing our customers with the best possible service but more information can be found in the Terms & Conditions about what to do if you have a complaint.',
    serviceCommitmentB:
      'We are committed to providing our customers with the best possible service but more information can be found in the Terms & Conditions about what to do if you have a complaint. ',
    overdraftFacilityB:
      'Borrowing is available on the B Current account, subject to eligibility.  Going overdrawn is usually more expensive if not arranged in advance. Planned borrowing costs £6 per month plus interest. Unplanned borrowing costs £6 per day. An item returned unpaid costs £15. Full details can be found in your Terms & Conditions and in your Tariff. Borrowing is not allowed on the B Instant Savings account.',
    packagedAccountOpening:
      'Both a current account and a savings account will be opened at the same time so you can take full advantage of all the features of the B app.',
    creditInterestPaid:
      'Credit interest is payable on both the current and the savings account; please refer to your Tariff for rates.',
    savingsWithdrawals:
      'You can’t make withdrawals directly from your B Instant Savings; you need to first transfer money into your B Current account and make the payment from there. You can transfer money from your B Instant Savings account to your B Current account, or any other account that we allow you to make a transfer into using one of our services. Apart from these transfers, you won’t be able to make payments directly to other accounts from B Instant Savings. No standing orders or Direct Debits can be set up on your B Instant Savings account.',
    creditBalanceMortgage:
      'Any credit balance in this account may be used to reduce the debit interest calculated on your mortgage account with us.',
    noticeOfChanges:
      'We will usually give you two months’ notice of any changes. The Terms & Conditions detail any that we may make sooner.',

    downgradedOfferPageKeyFeaturesTitle: 'Key features for the',
    downgradedOfferKeyFeaturesParagraph:
      'This section contains certain key information relating to this alternative offer of a Readycash Account. Full details are contained in your terms & conditions and tariff attached below which you should read.',

    // Offer Restrictions ReadyCash
    noCheckbook: 'Chequebook facilities.',
    noMortgageOffset: 'The ability to offset against a mortgage product.',
    noLinkedSavings: 'Linked savings account.',
    noBapp: 'The B app.',

    // SideBar
    sideBarTitle: 'Need help?',
    sideBarContentLine1: 'Call us on:',
    sideBarContentLine2: '0800 121 7365',
    sideBarContentLine3: 'Monday to Sunday 08:00 to 22:00.',
    sideBarContentLine4: undefined,
    sideBarContentLine5: undefined,

    // Footer
    footerLinkText1: 'Footer Link 1',
    footerLinkUrl1: '/',
    footerLinkText2: 'Footer Link 2',
    footerLinkUrl2: '/',
    footerLinkText3: 'Footer Link 3',
    footerLinkUrl3: '/',
    footerLinkText4: 'Footer Link 4',
    footerLinkUrl4: '/',

    // Landing Page
    landingPagePageHeader: 'B On Web',
    landingPageTitle: "You're applying for a ",
    landingPageIntro:
      "By the time you're finished, if all goes to plan, you should be all set up with a B Current account, B Instant Savings account and B Debit Card. You'll need to register for Internet and Telephone banking and will also have the option to use the Current Account Switch Service.",
    landingPageIntro1:
      'Please be aware our online application does not currently offer the ability to arrange an overdraft. If you require an overdraft and are planning to use the Current Account Switch Service, please call us or go into a branch.',
    landingPageQuestionsNote:
      'If you’re experiencing difficulties or there are other special circumstances related to your application, then it may be that our Basic Banking Account Readycash may suit your needs better than B. If you think this is the case, please call the team at B on 0800 678 3654 or call into one of our branches.',
    existingCustomerTitle: 'Existing customer?',
    initialQuestionsTitle: 'First, a few questions.',
    initialQuestionsSubtitle: undefined,
    infoToApplyTitle: 'Apply for B',
    infoToApplyIntro:
      "Before you start you'll need about 15 minutes and a few facts at your fingertips:",
    infoToApply1: "Where you've lived",
    infoToApply2: 'What you do for a living',
    infoToApply3: 'General information about your income and expenditure',
    infoToApply4: 'General information about your financial history',
    infoToApply5: '',
    isExistingCustomer:
      'Have you ever held an account with ' + brand.bankName + ' Bank?',
    isExistingCustomerHelpMessage:
      'Even if you held this account in the past, please select Yes.',
    isExistingCustomerValidationMessage:
      "Sorry, you can't apply online, so please call us instead and apply over the phone. Or, if you prefer, go into a branch and ask for help there.",

    infoToApplyFooter1: "Great. Let's go.",

    // Eligibility Questions
    eligibilityAge18Question: 'Are you 18 or over?',
    eligibilityAge18QuestionValidationMessage:
      "As you're under 18 please call, or pop into your local branch of Clydesdale or Yorkshire Bank for a chat.",
    eligibilityAge18QuestionHelpMessage:
      "To sign up for B online you need to be 18 or over. So if you're 16 or 17 you'll need to pop into a local branch of Clydesdale or Yorkshire Bank to go through your options.",
    eligibilityAge16Question: 'Are you 16 or over?',
    eligibilityAge16QuestionValidationMessage:
      'Sorry, but if you\'re under 16 we can\'t offer you this account at the moment. But we do have some other products that might be of interest. Click on the link to find out more: <a href="javascript:void(0)">CA Plus</a> &amp; <a href="javascript:void(0)">Jumpstart</a>',
    eligibilityAge16QuestionHelpMessage:
      'You need to be 16 or over to have a bank account.',

    eligibilityUKResidentQuestion: 'Do you live in the UK?',
    eligibilityUKResidentQuestionValidationMessage:
      "We need to ask you a few questions we can't cover online. Can you please call us and we'll explain what's involved.",
    eligibilityUKResidentQuestionHelpMessage:
      "You can answer Yes if you are a UK resident. Even if you were born abroad or used to live outside the UK. Feel free to call if you're unsure about anything.",
    eligibilityDeviceQuestion:
      'Got the right device? Are you sure B will work on both your tablet and mobile phone?',
    eligibilityDeviceQuestionValidationMessage:
      'You will need both a compatible tablet and a compatible mobile phone to take full advantage of all the features of the B app, though other mobile phones can still be used to receive SMS alerts',
    eligibilityDeviceQuestionHelpMessage:
      'For details of the operating systems and example mobile and tablet devices supported by the B app, please visit: <a href="http://www.youandb.co.uk/devices" target="_blank" title="www.youandb.co.uk/devices. This link will open in a new browser window">www.youandb.co.uk/devices <span class="screenreader">This link will open in a new browser window</span></a>.',

    // Terms & Conditions
    eligibilityTermsTitle: 'Using your personal information',
    eligibilityTerms1:
      'The information you provide will be used to assess your application, and set up and manage your accounts.',
    eligibilityTerms2:
      'A full description of how and for what purposes your information may be processed <a href="static/DU1950.pdf" target="_blank" title="Download Personal Information Statement PDF. This link will open in a new browser window" aria-label="Download Personal Information Statement PDF. This link will open in a new browser window.">can be viewed here <span class="screenreader">Download Personal Information Statement PDF. This link will open in a new browser window</span></a>.',
    eligibilityTerms3:
      'We will share your information with credit reference agencies to help determine what credit products and services we can provide you. These agencies will use the information for assessing credit applications, debt tracing and prevention of money laundering.',
    eligibilityTerms4:
      'If false or inaccurate information is provided and fraud is identified, details will be passed to fraud prevention agencies to prevent fraud and money laundering. Further details explaining how the information is held by fraud prevention agencies can be found in our Use of Personal Information Statement.',
    eligibilityTermsClosingText: undefined,
    acceptTsAndCs: 'I agree to the Use of Personal Information above.',
    dataProtectionDocDownloadLabel: 'Download as PDF',
    dataProtectionDocLink: 'static/DU1950.pdf',
    dataProtectionDocLinkTitle:
      'Download Personal Information Statement PDF. This link will open in a new browser window.',
    dataProtectionDocFileName: 'DU1950.pdf',
    dataProtectionDocVersion: 'I',

    // Step 1 - Your Details
    personalDetailsPageHeader: 'Personal details',
    personalDetailsTitle: 'Now for some form filling',
    personalDetailsGuidance:
      "As part of B's security measures you aren't able to change your details at this stage. But don't worry, if anything needs updating please call the team at B on " +
      brand.phoneNumber +
      '.',
    personalDetailsSubtitle: undefined,

    titleQuestion: 'Title',
    titleHelpMessage: 'Please select from the given list.',
    firstNameQuestion: 'First Name',
    firstNameValidationMessage: 'Please use letters and spaces only.',
    firstNameHelpMessage:
      'Just using letters and spaces as it appears on your passport or driving licence.',
    hasMiddleNameQuestion: 'Do you have a middle name?',
    hasMiddleNameHelpMessage:
      'Just using letters and spaces as it appears on your passport or driving licence.',
    middleNameQuestion: 'Middle Name',
    middleNameValidationMessage: 'Please use letters and spaces only.',
    lastNameQuestion: 'Last Name',
    lastNameValidationMessage: 'Please use letters and spaces only.',
    lastNameHelpMessage:
      'Please use your last name as it appears in your passport or driving licence.',
    dateOfBirthQuestion: 'Date of birth',
    dateOfBirthValidationMessage:
      'You need to be at least 18 to register for B.',
    dateOfBirthHelpMessage:
      "To sign up for B online you need to be 18 or over. So if you're  16 or 17 you'll need to pop into a local branch of Clydesdale or Yorkshire Bank to go through your options.",
    genderQuestion: 'Gender',
    genderHelpMessage: 'This is just to help identify you.',
    genderValidationMessage:
      'Please confirm if your title and gender are both correct on ' +
      brand.phoneNumber,
    maritalStatusQuestion: 'Marital status',
    maritalStatusHelpMessage: 'This is just to help identify you.',
    hasDependantsQuestion: 'Do you have any dependants?',
    hasDependantsHelpMessage:
      'A dependant is anyone who relies on your help and support - a child for instance.',
    personalDetailsFoundValidationMessage:
      'You look familiar... If you\'re already a customer <a href="/account-opening/authentication?applyFor={productCode}">please login to continue</a>.',

    // Step 1 - Addresses
    addressTitle: 'Where do you live?',
    addressSubtitle:
      "If you've lived at this address for less than three years, you'll need to add your other previous addresses too.",
    postcodeQuestion: 'Postcode',
    addressLookupError:
      'We were unable to look up your postcode. Please try again or contact us to proceed.',
    addressNoExactMatch: "Don't see your exact address? Contact us to proceed.",
    previousAddressTitle: 'Previous address',
    previousAddressSubtitle:
      "We need to know where you've been living for the last 3 years.",
    residentialStatusHelpMessage:
      'Choose the option that best describes your situation, so for instance if you pay a mortgage choose Owner.',
    residentialStatusValidationMessage:
      'Please select an option from the dropdown list.',
    residentialStatusQuestion: 'Living arrangement',
    dateMovedQuestion: 'When you moved here',
    removeAddressButtonLabel: 'Remove Address',
    postcodeSearchButtonLabel: 'Find address',
    postcodeSearchLegend: 'Postcode',
    selectAddressPlaceholder: 'Please select your address...',
    selectAddressLabel: 'Select your address',
    selectAddressSelectButtonText: 'Select',
    addressesQuestion: 'Postcode',
    addressTypeQuestion: 'Did you live in the UK?',
    addressInvalidMessage:
      "Something isn't right with your postcode, please contact the team at " +
      brand.bankName +
      ' on ' +
      brand.phoneNumber,

    // Step 1 - Contact Details
    contactDetailsTitle: 'Now for your contact details',
    contactDetailsIntro:
      'Please give the mobile phone number and email address you want to be used in future.',
    phoneNumberQuestion: 'Mobile number',
    phoneNumberValidationMessage:
      'This should be 11 characters long and numbers only. No spaces or symbols.',
    phoneNumberHelpMessage:
      'This should be 11 numbers long with no spaces or symbols. You must give a mobile number to be able to use the B app in full.',
    emailAddressQuestion: 'Email address',
    emailAddressValidationMessage:
      "Hmm. Can you check your email address please? Looks like there's a typo in there somewhere.",
    emailAddressHelpMessage:
      "If you don't want to receive offers by email tell us in the 'How would you like to be contacted?' section below. We'll still need your email address to send you important documents, including your Terms & Conditions.",
    emailAddressConfirmationQuestion: 'Confirm email address',
    emailAddressConfirmationValidationMessage:
      "Oops. Your email address doesn't match with the first. Can you give it another go?",
    emailAddressConfirmationHelpMessage:
      'Please type your email address again. Thanks.',
    contactMethodTitle: 'How would you like to be contacted?',
    contactMethodIntro:
      "Tell us how we can get in touch with you. When it comes to security, the team at B will always try to contact you on your mobile. You'll never get a request for your login details by email or text.",
    preferredContactMethodQuestion: "I'd prefer to be contacted by",
    contactMethodsValidationMessage:
      'Please select at least one contact method.',

    // Step 1 - Select Your Bank
    selectBankTitle: 'If you ever need to see us',
    selectBankQuestion: 'Which bank is handy for you?',
    selectBankSubtitle:
      'You’ll be able to manage your account online and you can call us too, but if you ever need to see us in person use the links below to find your nearest branch now.',
    bankIDHelpMessage:
      "Please select one of the banks, which seems the best fit for your location. Please call us if you're not sure.",
    bankIDValidationMessage: 'This is required.',
    selectBankHelpText:
      'For CHAPS and international payments, plus some other transaction types, you’ll have to visit your local branch.',

    selectBankHelpLinkCb: 'http://www.cbonline.co.uk/personal/online-locator/',
    selectBankHelpLinkCbText: 'Clydesdale Bank Branch Locator',
    selectBankHelpLinkCbTitle:
      'Clydesdale Bank Branch Locator link. This link will open in a new browser window',
    selectBankHelpLinkYb: 'http://www.ybonline.co.uk/personal/online-locator/',
    selectBankHelpLinkYbText: 'Yorkshire Bank Branch Locator',
    selectBankHelpLinkYbTitle:
      'Yorkshire Bank Branch Locator link. This link will open in a new browser window',

    // Step 1 - Username and Password
    // setPasswordTitle: 'Your username and password',
    setPasswordTitle: 'Set up your password',
    usernameInfo:
      "When you create your username and password make sure they’re memorable, as you'll need them to log on in future, for internet banking and signing up to the B app. The username you choose can't be changed and team at B won't be able to remind you of it if you forget it.",
    additionalUsernameInfo:
      "Once you've set them you'll be able to save your application form and log back in if you need to take a break.",
    unsavedUsernameHelpMessage:
      "Your username must be 6-16 characters in length, using only letters and numbers. It's also case sensitive.",
    unsavedUsernameValidationMessage:
      "Your username must be 6-16 characters in length, using only letters and numbers. It's also case sensitive.",
    usernameAlreadyInUseValidationMessage:
      'Sorry, that username happens to be already in use.',
    password1Question: 'Password',
    password2Question: 'Password (confirm)',
    passwordRequirements:
      "Your password should be 8-16 characters long with at least one letter, number and symbol. It's case sensitive too.",
    password1HelpMessage:
      "Your password should be 8-16 characters long with at least one letter, number and symbol. It's case sensitive too.",
    password1ValidationMessage:
      "It needs to be tougher than that. Your password should be 8-16 characters long with at least one letter, number and symbol. It's case sensitive too.",
    password2HelpMessage:
      "Your password should be 8-16 characters long with at least one letter, number and symbol. It's case sensitive too.",
    password2ValidationMessage:
      "Oops. Your passwords don't match. Please have another go.",
    passwordDisclaimer:
      'If you have to leave the application for any reason and want to save and log back in later, you can use the same password to login. This password will also be the one you use to sign up to the B app.',
    passwordLastWarning:
      'Never give your security details to anyone either in person, by email or by text. Clydesdale or Yorkshire Bank will NEVER email or text you asking for username or password, or for details of your accounts or cards.',

    // Employment Details
    employmentDetailsHeader: 'Employment details',
    employmentDetailsTitle: 'Employment details',
    employmentSectionTitle: 'You and your money',
    employmentSectionSubtitle: undefined,
    employmentSectionIntro: '',

    employmentStatusQuestion: 'Job status',
    employmentStatusHelpMessage:
      'Choose an option that best describes your job.',
    employmentOccupationHelpMessage: 'Which occupation is closest to yours?',
    employmentStartDateQuestion: 'When did you start work there?',
    employmentStartDateValidationMessage:
      'Sorry, your employment date doesn’t seem right. Try again?',
    employmentStartDateHelpMessage: 'What was your start date at this job?',
    employerNameValidationMessage:
      'Oops! You missed one. Please fill this in to keep going.',
    employerNameHelpMessage:
      'If you work for yourself just put your own name here',

    // Employment Details - Nationality
    nationalityTitle: 'Where are you from?',
    nationalityQuestion: 'Your nationality',
    nationalityHelpMessage: 'Please select your country of nationality.',
    cityBorn: 'City or town where you were born?',
    cityBornValidationMessage:
      'Letters and spaces only. No numbers or characters.',
    cityBornHelpMessage:
      "As it's written on your birth certificate or passport.",
    countryBorn: 'Country where you were born?',
    countryBornHelpMessage:
      "As it's written on your birth certificate or passport.",
    ukCitizen: 'Do you have a UK citizenship?',
    ukCitizenValidationMessage:
      'You must be a UK citizen in order to open an account.',
    ukCitizenHelpMessage:
      "If you have a UK passport you definitely have UK citizenship. If you have a visa and you're not sure if it covers citizenship please call the team at B on " +
      brand.phoneNumber +
      '.',
    hasAdditionalCitizenships:
      'Are you a citizen of any other country or countries?',
    hasAdditionalCitizenshipsValidationMessage:
      "If you're not a UK citizen, please tell us where you're from.",
    hasAdditionalCitizenshipsHelpMessage:
      "If you're a legally registered citizen of another country please tell us below.",
    citizenshipListQuestion: 'What country or countries?',
    citizenshipListValidationMessage:
      "Please select a country from each of the additional citizenship options you've selected.",

    // Employment Details - Tax
    taxObligationsTitle: 'Now for your tax status',
    taxStatusIntro:
      "Don't worry, this information won't be shared. If you're not sure about anything call the team at B on " +
      brand.phoneNumber +
      '.',
    hasNoTaxOligations: 'Are you a UK tax resident only?',
    hasNoTaxOligationsHelpMessage:
      'Choose "no" if you are not a UK tax resident OR if you have tax obligations in any country in addition to the UK.',
    taxCountryHelpMessage:
      'Which country(ies) do you have a tax obligation in? Please ensure you include details of all countries of tax residency, including the UK',
    taxNumberHelpMessage:
      'This is a code or number that is associated with your tax obligation, usually issued by the tax authority of your country of tax residence. It is mandatory that, if your country of tax residency does issue a tax ID number or equivalent, you must provide this for the country entered. If you do not know what this is, or do not have a tax ID for other reasons,  please call us.',
    allTaxObligationsListed:
      'I confirm that I have no tax obligations other than in the countries listed above.',
    allTaxObligationsListedValidationMessage:
      "Please list all the ways you're liable for tax.",
    allTaxObligationsListedHelpMessage:
      "If you've got a tax obligation that doesn't fit these options, please call us.",
    taxObligationListValidationMessage:
      "Please list all the ways you're liable for tax.",
    taxNumberNA: 'Country of Tax Residency does not issue a Tax ID number',
    taxNumberMissing: 'I do not have my Tax ID Number here',
    taxObligationsListCountryFieldName: 'Country of tax residency',
    taxObligationsListHasTaxNumberFieldName:
      'Does your country of tax residency issue a tax ID number?',
    taxObligationsListTaxNumberName: 'Tax ID',
    taxNumber0ValidationMessage:
      'Letters and numbers only (no symbols or punctuation)',
    taxNumber1ValidationMessage:
      'Letters and numbers only (no symbols or punctuation)',
    taxNumber2ValidationMessage:
      'Letters and numbers only (no symbols or punctuation)',
    taxNumber3ValidationMessage:
      'Letters and numbers only (no symbols or punctuation)',
    taxNumber4ValidationMessage:
      'Letters and numbers only (no symbols or punctuation)',

    // Employment Details- Income
    incomeSectionTitle: 'Money coming in',
    grossAnnualIncome: 'Roughly how much do you earn a year before tax?',
    grossAnnualIncomeValidationMessage:
      'Keep it simple please. No dots, commas or even a £.',
    grossAnnualIncomeHelpMessage:
      "If you're working, please enter your annual salary before tax. Otherwise please enter zero.",
    netMonthlyIncome:
      'Approximately how much goes into your bank account a month, after tax?',
    incomeSectionCurrentAccountSubtitle: 'Current Account Details',
    incomeSectionSavingsAccountSubtitle: 'Saving up',
    incomeSectionSavingsAccountIntro:
      "Imagine you could put some money aside to do more of the things you've always wanted to do.",
    netMonthlyIncomeValidationMessage:
      'Keep it simple please. No dots, commas or even a £. If your income goes up and down just type in an average. Your monthly income shouldn’t be more than your annual income divided by 12.',
    netMonthlyIncomeHelpMessage:
      'This is the amount you receive each month after tax and deductions. You can include the following incomes: salary, pensions and state benefits (such as disability living allowance, personal independence payment, carers allowance, reduced earnings allowance).',
    hasAdditionalIncome:
      'Aside from the above, do you bring in extra income from anything else?',
    hasAdditionalIncomeValidationMessage: 'Please select an answer.',
    hasAdditionalIncomeHelpMessage:
      "You might get rent in from somewhere or maybe you get interest from investments? If it's something that you declare on your tax returns, you should add it here.",
    incomeOtherAmount: 'What does that extra income add up to over a year?',
    incomeOtherAmountValidationMessage:
      'Please estimate how much extra income you earn a year, not including your salary.',
    incomeOtherAmountHelpMessage:
      "Try to come up with a rough estimate that doesn't include your salary.",
    incomeOtherFrequency: 'That money tends to come in',
    incomeOtherFrequencyOptionsHelpMessage:
      "It's possible that income might come unpredictably or at different times. If there is an option that makes sense for the majority of your payments, please choose it. Otherwise, please call us.",

    incomeOtherSavingsAmount: 'How much might you be able to put away a year?',
    incomeOtherSavingsAmountValidationMessage:
      'Put in a whole number please, without spaces or commas. For example 5000.',
    incomeOtherSavingsAmountHelpMessage:
      "Tell us an overall amount you hope to save annually. If you're not sure, add in a realistic number, perhaps based on previous savings habits.",
    incomeOtherSavingsFrequency: 'How often would you like to put money aside?',
    incomeOtherSavingsFrequencyHelpMessage:
      "If you're not sure, pick an interval that seems most likely. This is just to get you started.",

    incomeOtherPaymentAmount: 'How much will you pay in each month?',
    incomeOtherPaymentAmountValidationMessage:
      'Put in a whole number please, without spaces or commas. For example 3000.',
    incomeOtherPaymentAmountHelpMessage:
      'This is an overall monthly figure which indicates how much income you plan to pay into your new account.',
    incomeOtherAccountPurpose:
      'What is your main reason for having an account with B?',
    incomeOtherAccountPurposeHelpMessage:
      'Please select the main reason for having this account. If there are a few reasons there that make sense to you, just pick one you know is important.',
    incomeOtherAccountPurposeValidationMessage: 'Please select an answer.',
    incomeOtherPaymentType:
      'What will you pay into B? Will it be your salary or another source of income?',
    incomeOtherPaymentTypeOptionsHelpMessage:
      'Choose the option that feels the most relevant one to you. This should incorporate all your income sources.',
    incomeOtherPaymentTypeOptionsValidationMessage:
      'Please select one of the options.',

    // Employment Details - Expenses
    expenditureSectionTitle: 'And money going out',
    mortgageOrRentExpenditure:
      'How much do you pay a month on the mortgage and/or rent?',
    mortgageOrRentExpenditureValidationMessage:
      'Please type in a whole number for the overall monthly amount, for example 1200.',
    mortgageOrRentExpenditureHelpMessage:
      'Just the basic figure, not extras like council tax, heating bills or service charges.',
    expenditureOther:
      'Roughly how much do you pay out on personal loans, credit cards and hire purchase agreements?',
    expenditureOtherValidationMessage:
      'Please type a figure without adding any pence, dots or commas.',
    expenditureOtherHelpMessage:
      'The amount you enter here should be the total monthly amount you pay on any personal loans, credit cards and hire purchase agreements.',

    // Review Page
    reviewPageHeader: 'Review',
    reviewTopTitle: 'Review and submit your application',
    reviewTopSubtitle: 'Almost there. Now for a quick review.',
    reviewTopParagraph:
      "Please double-check that your contact details are all correct in the summary below. Some you’ll be able to edit yourself but if anything's not quite right please call the team at B on " +
      brand.phoneNumber +
      ' and ask them to make changes for you. ',
    reviewTopTermsParagraph:
      'Please read all the important information below. It includes Key Features, Terms & Conditions, Lending Code information and Tariff details.',
    reviewPageTitle: 'Review and submit your application',

    reviewPersonalDetailsTitle: 'Your details',
    reviewSectionPersonalTitle: 'About you',
    reviewSectionContactTitle: 'Contact details',
    reviewSectionNationalityTitle: 'Where you are from',
    reviewEmploymentDetailsTitle: 'Employment details',
    reviewSectionEmploymentTitle: 'Employment details',
    reviewSectionIncomeTitle: 'Your money',
    reviewSectionOutgoingsTitle: 'Money out',
    reviewTermsDocumentsTitle: 'Documents for you to read and save',
    reviewTermsDocumentsParagraph:
      'We will also email you these four documents after you have opened a ',
    reviewImportantInformationTitle: 'Important information',

    termsAndConditionsDocLinkText: 'Terms & Conditions',
    termsAndConditionsDocLinkTitle:
      'Download Terms & Conditions PDF. This link will open in a new browser window.',
    termsAndConditionsDocLink: 'static/{}/personal-account-terms.pdf',
    termsAndConditionsDocFileName: 'personal-account-terms.pdf',
    termsAndConditionsDocVersion: '0916',
    lendingCodeDocLinkText: 'A guide to the Lending Code',
    lendingCodeDocLinkTitle:
      'Download Lending Code PDF. This link will open in a new browser window.',
    lendingCodeDocLink: 'static/lending-code.pdf',
    lendingCodeDocFileName: 'lending-code.pdf',
    lendingCodeDocVersion: '1.0',
    currentTariffDocLinkText: 'Tariff details',
    currentTariffDocLinkTitle:
      'Download Tariff Details PDF. This link will open in a new browser window.',
    currentTariffDocLink: 'static/{}/current-account-tariff.pdf',
    currentTariffDocFileName: 'current-account-tariff.pdf',
    currentTariffDocVersion: '0916',
    CA31DocLink: 'static/{}/CA31.pdf',
    CA31DocLinkText: 'Current Account Control Factsheet',
    CA31DocLinkTitle:
      'Download Current Account Control Factsheet PDF. This link will open in a new browser window.',
    CA31DocVersion: '1.0',
    financialServicesCompensationSchemeDocLinkText:
      'Financial Services Compensation Scheme Information Sheet',
    financialServicesCompensationSchemeDocLinkTitle:
      'Download Financial Services Compensation Scheme Information Sheet PDF. This link will open in a new browser window.',
    financialServicesCompensationSchemeDocLink:
      'static/FSCS_Information_Sheet_DU728.pdf',
    financialServicesCompensationSchemeDocName:
      'FSCS_Information_Sheet_DU728.pdf',
    financialServicesCompensationSchemeDocVersion: '1215',
    reviewKeyFeaturesTitle: 'Key features for the',
    reviewOfferRestrictionsTitle: "This offer doesn't include:",
    reviewAcceptTsAndCs:
      'By ticking this box and clicking "Submit" this represents my signature confirming that:',

    // Review page labels - capital LABEL so last section can match up to name of the form element
    reviewLabelsectionPersonalDetails: 'Personal details',

    reviewLabeltitle: 'Title',
    reviewLabelfirstName: 'First Name',
    reviewLabelmiddleName: 'Middle Name',
    reviewLabellastName: 'Last Name',
    reviewLabeldateOfBirth: 'Date of Birth',
    reviewLabelgender: 'Gender',
    reviewLabelmaritalStatus: 'Marital Status',
    reviewLabeldependants: 'No. of Dependants',
    reviewLabeladdresses: 'Address',
    reviewLabelresidentialStatus: 'Residential Status',
    reviewLabeldateMoved: 'Date Moved',
    reviewLabelPreviousaddresses: 'Previous Address',

    reviewLabelsectionContactDetails: 'Contact details',

    reviewLabelemailAddress: 'Email Address',
    reviewLabelpreferredContactMethod: 'Preferred Contact Method',
    reviewLabelphoneNumber: 'Phone Number',

    reviewLabelsectionNationality: 'Nationality',

    reviewLabelnationality: 'Nationality',
    reviewLabelcountryBorn: 'Country of Birth',
    reviewLabelcityBorn: 'City of Birth',
    reviewLabelukCitizen: 'UK Citizen',
    reviewLabelcitizenshipList: 'Additional Citizenships',
    reviewLabeltaxObligations: 'Additional Tax Obligations',
    reviewLabelallTaxObligationsListed: 'All Tax Obligations Listed',

    reviewLabelsectionEmployment: 'Employment details',

    reviewLabelemploymentStatus: 'Employment Status',
    reviewLabelemploymentOccupation: 'Occupation',
    reviewLabelemployerName: 'Employer Name',
    reviewLabelemploymentStartDate: 'Start Date',

    reviewLabelsectionIncome: 'Income',

    reviewLabelgrossAnnualIncome: 'Gross Annual Income',
    reviewLabelnetMonthlyIncome: 'Net Monthly Income',
    reviewLabelincomeOtherAmount: 'Additional Income',
    reviewLabelincomeOtherFrequencyOptions: 'Frequency',

    reviewLabelsectionCA: 'Current Account',

    reviewLabelincomeOtherAccountPurpose: 'Account Purpose',
    reviewLabelincomeOtherPaymentTypeOptions: 'Account Use For',
    reviewLabelincomeOtherPaymentAmount: 'Monthly Pay In',

    reviewLabelsectionSA: 'Savings Account',

    reviewLabelincomeOtherSavingsAmount: 'Pay In Amount',
    reviewLabelincomeOtherSavingsFrequency: 'Frequency',

    reviewLabelsectionOutgoings: 'Outgoings',

    reviewLabelmortgageOrRentExpenditure: 'Mortgage / Rent',
    reviewLabelexpenditureOther: 'Other',

    // DGS Documents
    reviewAcceptSaDgs:
      'Yes, I agree to the Savings Account Deposit Guarantee Scheme',
    reviewAcceptCaDgs:
      'Yes, I agree to the Current Account Deposit Guarantee Scheme',
    DGSDocLink: 'static/CYB00174_FSCS Information Sheet _079601_v10.pdf',
    DGSDocLinkTitle:
      'Download Deposit Guarantee Scheme Information Sheet PDF. This link will open in a new browser window.',
    DGSDocName: 'Deposit Guarantee Scheme Information Sheet',
    DGSDocFileName: 'CYB00174_FSCS Information Sheet _079601_v10.pdf',
    DGSDocVersion: '10.0',

    // Marketing Prefs
    marketingPrefsTitle: 'Marketing stuff',
    marketingPrefsText:
      "When we have new stuff we think you'd find useful, we'd like to tell you about it. If that's okay with you, let us know the best way to do that here. We should say, whatever you choose will replace anything you've already told us about this (so if you've said Phone before but say Email now).",
    marketingPrefsSmsDYB: '',

    // Offer Page
    offerItemCurrentAndSavingsAccounts:
      'Both a B Current Account and a B Instant Savings account.',
    offerItemSelfService: 'Access to the B app',
    offerItemWithInterest:
      'Ongoing 2% AER (variable) interest on balances up to £3000',
    offerItemDebitContactless:
      'A Debit MasterCard for your B Current account with contactless functionality as well as allowing you to withdraw cash at any UK ATM, subject to available funds. We will tell you your daily withdrawal limit when we send you your B debit card.',
    offerItemDebitContactlessLimited:
      'A Debit MasterCard Online Only card for your B Current Account with Contactless functionality allowing you to withdraw up to £350 a day at any UK ATM, subject to available funds.',

    offerItemCaControl:
      'A Debit MasterCard Online Only card with Contactless functionality allowing you to withdraw up to £350 a day at any UK ATM, subject to available funds.',
    // ready cash offers
    offerItemReadyCash:
      'A Debit MasterCard Online Only card with Non contactless functionality allowing you to withdraw up to £350 a day at any UK ATM, subject to available funds.',
    offerItemNoFees: 'There are no fees or charges for this account.',
    offerItemNoCreditInterest: "This account doesn't pay credit interest.",
    offerItemNoOverdrafts: 'Overdrafts are not permitted.',
    offerItemNoBorrowing:
      'Borrowing is not available on this account. Requests for unplanned borrowing will usually be declined. {termsAndConditionsDoc}',
    offerItemDebitCard:
      'You will receive a Debit MasterCard Online Only card with non contactless functionality allowing you to withdraw up to £350 a day at any Clydesdale ATM or UK ATM, subject to available funds.',
    offerItemDeposits:
      'Your eligible deposits with Clydesdale Bank PLC are protected up to a total of £75,000 by the Financial Services Compensation Scheme, the UK’s deposit guarantee scheme. This limit is applied to the total of any deposits you have with Clydesdale Bank, Yorkshire Bank and B. Any total deposits you hold above the limit between these brands are unlikely to be covered. Please see <a href="http://www.cbonline.co.uk/resources/b82e172a-b00f-4783-973b-e4399da349e4/fscs_2015_online-leaflet.pdf" target="_blank" title="www.fscs.org.uk. This link will open in a new browser window">FSCS leaflet<span class="screenreader"> This link will open in a new browser window</span></a> for further information or visit <a href="http://www.fscs.org.uk" target="_blank" title="www.fscs.org.uk. This link will open in a new browser window">www.fscs.org.uk<span class="screenreader"> This link will open in a new browser window</span></a>',
    offerItemCancelation:
      'You can cancel your agreement with us within 14 days of opening the account, or from the day you receive the Terms & Conditions, if later, by contacting us in branch, by phone or in writing. You will need to repay any debit balance, interest and fees incurred within 30 days of the date you tell us you want to cancel it.',

    offerItemCaDirectCaPlus:
      'A Debit MasterCard with Contactless functionality as well as allowing you to withdraw cash at any UK ATM, subject to available funds. We will tell you your daily withdrawal limit when we send you your Debit MasterCard.',

    offerPageUnsuccessfulTitle:
      'We are sorry, it appears that you are not eligible for the {productTitle} as you don’t hold the appropriate current account',
    offerPageDowngradeTitle:
      'Unfortunately you have been unsuccessful for the {productTitle}',
    offerPageAlternativeOfferTitle: 'However we can offer you our ',
    offerPageHeader: 'Offer',
    offerPageTitle: 'Happy days. You can open B.',
    offerPageAltTitle: 'We are please to offer you a ',
    offerPageSubTitle: 'This offer includes:',
    offerPageIntroTitle:
      'This section contains certain key information relating to the Readycash Account. Full details are contained in your Terms & Conditions and Tariff attached below which you should read.',

    offerPageKeyFeaturesTitle: 'Key features for',
    offerPageofferRestrictionsTitle: "This offer doesn't include:",
    offerPageDocumentToReadSectionTitle: 'Documents for you to read and save:',
    offerPageDeclineOffer:
      "If there's something you're undecided about, please call us on " +
      brand.phoneNumber +
      ' or go into a branch.',
    offerConditionsIntro:
      'You will receive these by email after you have opened the account.',
    offerTandCQuestion:
      'By ticking this box and clicking "Yes Open my account" this represents my signature confirming that:',
    offerPageContinue: 'Do you wish to continue with the offer of a ',
    openAccountButton: 'Yes, open my account',
    declineAccountButton: 'No, do not proceed',
    downgradedOfferPageEmail:
      'We will also email you these four documents after you have opened the account',

    // Offer Page Mandate
    mandateTitle: '',
    mandateParagraph:
      "By clicking the 'Yes, open my account' button, this confirms my signature and authority, and that I am opening an account.",

    // Savings Account Information
    savingsAccountInformation1:
      'For more information regarding the savings account, please see the Terms & Conditions',

    // Mutli Offer & Modal
    altOpenAccountButton: 'Accept offer',
    altDeclineAccountButton: 'Decline offer',
    offerCancelApplicationBtn: 'Cancel application',
    offerCancelApplicationModalTitle:
      'Are you sure you want to cancel this application?',
    offerCancelApplicationConfirm: 'Yes',
    offerCancelApplicationDecline: 'No',
    offerCancelIntro:
      'If you do not wish to proceed with your application you can cancel below',

    // Mandate items
    mandateBullet1: 'I wish to apply for the B accounts and B App',
    mandateBullet2:
      'I have read and accept the Terms & Conditions and Tariff for B accounts and B App. And I have also saved or printed a copy of the Terms & Conditions and Tariff',
    mandateBullet3:
      'I acknowledge receipt of the Financial Services Compensation Scheme Information Sheet for both B Current account and B Instant Savings account',
    mandateBullet4:
      'I authorise you to undertake any necessary searches and credit checks required to validate my identity and address, and',
    mandateBullet5:
      'If my application is accepted and I proceed to open the B accounts, I authorise you to debit to the accounts all cheques, orders, payments and withdrawals signed or otherwise authorised by me. I also authorise you to debit to the B Current account all transactions made by using any debit cards that you may issue to me',
    mandateBullet6: undefined,
    mandateBullet7: undefined,
    mandateBullet8: undefined,
    mandateBullet9: 'I wish to apply for the account',
    mandateBullet10:
      'I have read and accept the Terms & Conditions and Tariff. And I have also saved or printed a copy of the Terms & Conditions and Tariff',
    mandateBullet11:
      'I acknowledge receipt of the Financial Services Compensation Scheme Information Sheet',
    mandateBullet12:
      'I authorise you to undertake any necessary searches and credit checks required to validate my identity and address, and',
    mandateBullet13:
      'If my application is accepted and I proceed to open the account, I authorise you to debit to the account all cheques, orders, payments and withdrawals signed or otherwise authorised by me. I also authorise you to debit to the account all transactions made by using any debit cards that you may issue to me',

    // Deferred Page
    deferredPageHeader: 'Deferred',
    deferredPageTitle: 'We need more time to look at your application.',
    deferredPageExplanation:
      'A team member needs to go over your application in more detail. We will do this within two working days and you will be notified by email or SMS with a link to log in and see the decision.',

    // ID Deferred Page
    idDeferredPageHeader: 'Verify your identity',
    idDeferredPageTitle: 'We need to see your ID in person',
    idDeferredPageExplanation:
      'We have been unable to verify your identity. You will need to pop into any branch of Clydesdale or Yorkshire Bank to apply for your B account.',
    idDeferredPageNextStepsItems: ['Passport', 'Driving license'],
    idDeferredLinkTitle:
      'Download ID Requirements Factsheet PDF. This link will open in a new browser window.',
    idDeferredLinkText:
      'For details on what ID to bring with you please click here. Cheers.',
    idDeferredLinkUrl:
      'http://www.cbonline.co.uk/wcm-media/CYB-Identificatio-Requirements.pdf',

    // Contact Bank Page
    contactBankPageHeader: 'We need your number',
    contactBankPageTitle: 'We need your number',
    contactBankPageExplanation:
      'To continue your application the team at B need you to update your mobile details. Please give them a call on ' +
      brand.phoneNumber +
      '.',

    // Account Locked Page
    accountLockedPageHeader: 'Account Locked',
    accountLockedPageExplanation1:
      "Sorry. We've had to lock your account to ensure it's kept secure.",
    accountLockedPageExplanation2:
      'You can unlock your account by resetting your password.',
    accountLockedPageExplanation3:
      'Alternatively, you can contact support on <strong>' +
      brand.phoneNumber +
      '</strong>.',
    accountLockedPageExplanation4:
      'Please quote your ID: <strong>{quote_id}</strong>',
    accountLockedPageResetPasswordButtonLabel: 'Reset your password',

    // Session Timeout Text
    sessionTimeout: 'Your session has timed out.',

    // Sorry Page
    sorryPageHeader: 'Sorry',
    sorryPageTitle: "Sorry, we can't offer you B.",
    sorryPageExplanation1:
      "Thank you for applying for B. I'm sorry, but based on our own credit scoring system, and information from outside credit reference agencies - Experian and Callcredit - we're unable to offer you B at the moment. We will send you a letter in the post to confirm this decision. You can request a copy of your report from the credit reference agencies by clicking on the links below. Just bear in mind that they may charge you a fee for this.",
    sorryPageExplanation2: '{findOutMore}',
    sorryPageExplanation3DYB:
      'If you think there are special circumstances related to your application, you can call us to discuss it on ' +
      brand.phoneNumber +
      '. Lines are open Monday to Friday 08:00 to 20:00, closed on Saturday and Sunday.',
    sorryFindOutMore: '',
    sorryPageFormLink:
      'http://www.experian.co.uk/consumer/statutory-report.html',
    sorryPageFormLink2: 'http://www.callcredit.co.uk',
    sorryPageFormLinkText: 'Click here to visit Experian website',
    sorryPageFormLinkText2: 'Click here to visit Callcredit website',
    sorryPageFormLinkTitle: 'This link will open in a new window',
    sorryPageFormLinkTitle2: 'This link will open in a new window',

    // Decline Page
    declinePageTitle:
      'We are sorry but after careful consideration we declined your application for {}. We note you did not proceed with our offer of an alternative product.',
    declinePageParagraph1:
      'We use a Credit Scoring System and information from credit reference agencies, Experian and Callcredit, to ensure we assess all credit applications fairly and consistently. You can request a copy of your report from the credit reference agencies by clicking on the link below.',
    declinePageParagraph2:
      'If you think there are special circumstances related to your application, you can call us to discuss it on ' +
      brand.phoneNumber +
      '. Lines are open Monday to Friday 08:00 to 20:00, closed on Saturday and Sunday. We will send you a letter in the post to confirm this decision.',
    declinePageLink1:
      '<a href="http://www.experian.co.uk/consumer/statutory-report.html" target="_blank" title="www.experian.co.uk/consumer/statutory-report.html This link will open in a new browser window">Click here to visit Experian website <span class="screenreader"> This link will open in a new browser window.</span></a>',
    declinePageLink2:
      '<a href="http://www.callcredit.co.uk" target="_blank" title="www.callcredit.co.uk This link will open in a new browser window">Click here to visit Callcredit website <span class="screenreader"> This link will open in a new browser window.</span></a>',

    // Registration Page
    registrationPageHeader: 'Registration',
    registrationPageTitle: 'Congratulations',
    registrationPageSubTitle:
      "You'll be needing these account details. Got a pencil?",
    registrationPageParagraph1:
      "To give you a backup in case you ever lose your phone or tablet, we recommend you register for internet and telephone banking now. You'll need your customer number (up there) and the password you created at the start of this form. You should also definitely write down/ copy and paste/ screenshot your customer number now as you'll need it to download the app",
    registrationPageParagraph2:
      "You'll also need a telephone access code. (That bit comes later.)",
    registrationPageBulletParagraph:
      "For internet banking you'll need the following details to log in:",
    registrationPageBullet1: undefined,
    registrationPageBullet2: undefined,
    registrationPageBullet3: 'Set up Internet Banking',
    registrationPageErrorMessage:
      'There has been a problem registering your {0} credentials. The reason is {1}.',
    // Alternative YB/CB rgistration content
    registrationPageHeaderCYB: 'Registration',
    registrationPageTitleCYB: 'Congratulations, your account has been opened',
    registrationPageSubTitleCYB:
      "Your account details and information you'll need to make a note of",
    registrationPageParagraph1CYB:
      "Now that your account is opened, let's register you for Internet and Telephone Banking services so that you can use your account straight away.",
    registrationPageParagraph2CYB:
      "For Telephone Banking you'll need your customer number – again it's above, and your telephone PIN – which you can set up below.",
    registrationPageBulletParagraphCYB:
      "For Internet Banking you'll need the following details to log in:",
    registrationPageBullet1CYB: 'your customer number - which is above',
    registrationPageBullet2CYB:
      'your password - which you created at the start of this application',
    registrationPageBullet3CYB:
      'your security questions for Internet Banking - which you can set up below',
    registrationPageErrorMessageCYB:
      'There has been a problem registering your {0} credentials. The reason is {1}.',

    securityQuestionsTitle: 'Set up your internet banking',
    securityQuestionsSubTitle:
      'Please choose some security questions and answers. These will be used when you log in to internet banking.',

    securityPageLoadingMessage: 'Loading...',
    securityPageSubmissionMessage: 'Submitting answers...',

    securityQuestionDropdownValidationMessage:
      "Sorry, you can't select the same question twice.",
    securityQuestionInputValidationMessage:
      'Your answer must be 6-20 characters long, and only contain letters and numbers.',
    securityQuestionDropdownHelpText:
      'These questions are a safeguard against the risk of fraud and make your log in to internet banking more secure.',
    securityQuestionInputHelpText:
      'Type in a simple answer that you can easily remember for each question. Your answer must be 6-20 characters long, and only contain letters and numbers.',
    telephonePinTitle: 'Telephone banking',
    telephonePinHelpMessage:
      "Your telephone access code is a special code you'll use to identify yourself when you phone up to use telephone banking. It's an important security measure. It needs to be a 4 digit number which you can easily remember. Don't use the same number more than three times, or have any sequential numbers in there like 1234.",
    telephonePinValidationMessage:
      'Pick a 4 digit number, with no consecutive numbers, and without using the same number four times.',
    telephonePin2HelpMessage:
      'This needs to be exactly the same as the PIN entered in the box above.',
    telephonePin2ValidationMessage: "Try again? The PIN numbers didn't match.",
    registrationTCsTitle:
      'Download and save the Terms & Conditions for telephone and internet banking for your records. These will also be emailed to you.',
    registrationTsAndCsDocLink: 'static/rib-tb-terms.pdf',
    registrationTsAndCsDocVersion: '0815',
    registrationTsAndCsText:
      'Terms & Conditions for telephone and internet banking',
    registrationTsAndCsDocLinkTitle:
      'Download Terms & Conditions for telephone and internet banking PDF. This link will open in a new browser window.',
    registrationAcceptTCs:
      'I confirm by ticking this box that I agree to the Terms & Conditions above.',
    registrationAcceptTCsValidationMessage:
      'You need to agree in order to carry on.',

    alreadyRibRegistered:
      "It looks like you're already signed up for internet banking, you don't need to do anything more here.",
    alreadyTBRegistered:
      "It looks like you're already signed up for telephone banking, you don't need to do anything more here.",

    // Submission Page
    submissionPageHeader: 'Submission',
    submissionPageTitle: 'Thank you for sending your application',
    submissionPageText: 'Please wait while your details are checked',

    // Security Page
    securityPageTitle: 'Nearly there',
    timerSectionTitle: 'Just tell us a bit more about yourself',
    timerSectionTimeUnitDescription: 'mins',
    timerSectionTimeUnitExpiredDescription:
      "Sorry, but you've run out of time.",

    // Account Opened Page
    accountOpenedPageHeader: 'Account Opened',
    accountOpenedPageTitle: "You're good to go",
    accountOpenedAppDownloadTitle: 'Now you can download the B app',

    accountOpenedSection1Title: "What's next?",
    accountOpenedSection1Bullet1:
      "Within the next few days, the team at B will email you with important T&Cs, the B Tariff and other documents to read and save. If you can't see their message, please check your junk and spam just in case it's landed there.",
    accountOpenedSection1Bullet2:
      'You’re all registered for internet banking too. You can use this straight away by going to the login button at the top right of any page on <a href="' +
      brands.CB.bankWebsite +
      '" target="_blank" title="www.cbonline.co.uk. This link will open in a new browser window">www.cbonline.co.uk<span class="screenreader"> This link will open in a new browser window</span></a> or <a href="' +
      brands.YB.bankWebsite +
      '" target="_blank" title="www.ybonline.co.uk. This link will open in a new browser window">www.ybonline.co.uk<span class="screenreader"> This link will open in a new browser window</span></a>. You\'ll need your customer number, password and security details.',
    accountOpenedSection2Title: 'Look out for the post too:',
    accountOpenedSection2Bullet1:
      'Your B Debit MasterCard and PIN will arrive separately in around 3-5 days.',
    accountOpenedSection2Bullet2:
      "If you'd like a cheque book as well please call the team at B on " +
      brand.phoneNumber,
    accountOpenedSection3Title: 'With B, you can also:',
    accountOpenedSection3Bullet1:
      'Arrange to include your B accounts in mortgage offsetting arrangements (this won’t be done automatically)',
    accountOpenedSection3Bullet2:
      'Apply for an overdraft (subject to eligibility)',
    accountOpenedSection3Bullet3:
      'Apply for a credit card or a personal loan (subject to eligibility)',
    accountOpenedSection3Bullet4:
      'For any of these, please get in touch with the team at B on ' +
      brand.phoneNumber,
    accountOpenedSection4Title: 'P.S. Here are some useful links:',
    accountOpenedSection4Bullet1:
      'Any questions? Find out the answers <a href="https://www.youandb.co.uk/faq/tablet" target="_blank" title="Tablet FAQs. This link will open in a new browser window">here<span class="screenreader"> This link will open in a new browser window</span></a>',
    accountOpenedSection4Bullet2: '',
    accountOpenedSection5Title: '',
    accountOpenedSection5Bullet1: '',
    // Alt CYB content for account opened
    accountOpenedPageTitleCYB: "Good news, you're all done",
    accountOpenedSection1TitleCYB: 'Check your email',
    accountOpenedSection1Bullet1CYB:
      "In the next few days we will send you an email with important information for you to read and save. Check your email filters in case it's gone straight to your junk/spam folder and you can't see it in your inbox",
    accountOpenedSection1Bullet2CYB:
      'You’re all registered for internet banking too. You can use this straight away by going to the login button at the top right of any page on <a href="' +
      brands.CB.bankWebsite +
      '" target="_blank" title="www.cbonline.co.uk This link will open in a new browser window">www.cbonline.co.uk <span class="screenreader">This link will open in a new browser window</span></a> or <a href="' +
      brands.YB.bankWebsite +
      '" target="_blank" title="www.ybonline.co.uk This link will open in a new browser window">www.ybonline.co.uk <span class="screenreader">This link will open in a new browser window</span></a>. You\'ll need your customer number, password and security details.',
    accountOpenedSection2TitleCYB: 'Look out for your post',
    accountOpenedSection2Bullet1CYB:
      'You will receive a welcome letter which will confirm the details of your new account, please read through and send us back your specimen signature, as we’ll need this so you can make certain transactions on your account',
    accountOpenedSection2Bullet2CYB:
      'Your Debit MasterCard and PIN are on their way. These will come separately and will be with you within 3-5 working days',
    accountOpenedSection3TitleCYB: 'Useful links',
    accountOpenedSection3Bullet1CYB:
      'Download our mobile banking app <a href="' +
      brand.monetiseLink +
      '" target="_blank" title="Click here to download our mobile banking app. This link will open in a new browser window">here <span class="screenreader">Click here to download our mobile banking app. This link will open in a new browser window</span></a>',
    accountOpenedSection3Bullet2CYB:
      '<a href="' +
      brand.faqsLink +
      '" target="_blank" title="FAQs. This link will open in a new browser window">FAQs <span class="screenreader">This link will open in a new browser window</span></a> to help answer any queries you may have',
    accountOpenedSection3Bullet3CYB: '',
    accountOpenedSection4TitleCYB: 'Contact us',
    accountOpenedSection4Bullet1CYB:
      'If you have any queries about your new account',
    accountOpenedSection5TitleCYB: 'Ways to contact us',
    accountOpenedSection5Bullet1CYB:
      'Call us on ' + brands.YB.phoneNumber + ' or pop in to your local branch',

    // Portal Page
    portalPageHeader: 'Portal',
    portalPageTitle: 'Your saved applications',
    portalPageSubTitle: 'Pick an application to carry on with',

    // Login Page
    loginPageHeader: 'Login',
    loginPageTitle: 'Your saved application',
    loginPageNextButtonLabel: 'Please log in to carry on',
    usernameLabel: 'Customer Number/Username',
    usernameValidationMessage:
      "Here you can use either your Customer Number or Username. Your Customer Number is 10 numbers long, detailed in your Internet Banking Welcome Letter. Your username is 6-16 characters long, and can be letters and numbers. It's also case sensitive.",
    usernameHelpMessage:
      'This is your customer number or username you created when you registered to save your application earlier on. Please call us if you need help.',
    passwordLabel:
      "Please type the characters we've requested from your Internet Banking password. The password characters are case sensitive.",
    passwordValidationMessage:
      "Type the characters we've requested from your password.",
    passwordHelpMessage:
      'This is the password you created when you registered for Internet Banking earlier. Please call us if you need help.',
    passwordCharacterPrefix: 'Character ',
    goneWrongMessage:
      'Can you check your details and try again please? Something went wrong but it might work if you try again.',
    tooManyRetries:
      'You have exceeded the maximum number of login attempts. Please try again later.',
    cannotBeLoggedIn:
      'Sorry we cannot log you in at this time. Please contact us for support.',

    // OTP Authentication Overlay
    OTPTitle: "We've sent a passcode to your mobile",
    OTPAuthenticationTitle:
      "We've sent a passcode to your mobile ending {partial-phone-number}",
    OTPAuthenticationAltTitle: "We've sent a passcode to your mobile",
    OTPAuthenticationSubTitle:
      "You should have received a text on your mobile ending {partial-phone-number} You can't proceed past this point unless we have a mobile number saved for you. If you need help call us on " +
      brand.phoneNumber +
      '.',
    OTPAuthenticationAltSubTitle:
      "You should have received a text on your mobile. You can't proceed past this point unless we have a mobile number saved for you. If you need help call us on " +
      brand.phoneNumber +
      '.',

    OTPAuthenticationTitleResent: "We've sent you another passcode.",
    OTPAuthenticationSubTitleResent:
      'Check your mobile ending {partial-phone-number}',
    passcodeValidationMessage:
      'This passcode is required and should be a number of exactly 10 characters.',
    OTPAuthenticationTitleNoOTP: 'Something went wrong',
    OTPAuthenticationSubTitleNoOTP: 'Please try that again.',
    OTPAuthenticationTitleInvalidOTP: "That's not the right passcode.",
    OTPAuthenticationSubTitleInvalidOTP:
      "Try again please. The passcode you entered isn't the same as the one we texted you.",

    // Switch Page
    switchPageHeader: 'Switch',
    switchPageTitle: "Switch to B. It's easy and there's a guarantee",
    switchPageHeadingOptional1:
      "The switch guarantee means it's really straightforward",
    switchPageText1:
      "First of all the team at B will do everything for you, you won't even have to get in touch with your old bank.",
    switchPageHeadingOptional2: 'Make sure you arrange an overdraft first',
    switchPageText2:
      "If you have an overdraft on your old account, you'll need to contact the team at B before you switch on " +
      brand.phoneNumber +
      " to make sure you get one with B. If you're eligible and you're using your overdraft at the moment, your balance will be carried across, even if it's in debit, subject to checks of course. If you prefer speaking to someone in person, you can also pop into a branch of Clydesdale or Yorkshire Bank. Staff will be more than happy to help.",
    switchPageHeadingOptional3: '',
    switchPageText3: '',
    switchPageHeadingOptional4: 'A word in your ear',
    switchPageText4:
      "Once switching has started it can't be stopped, but the guarantee means that if anything goes wrong, tell B and you'll get a refund of any interest or charges made on either your old account or the new one as a result. If, for any reason, you don't qualify for the Current Account Switch Service, or you don't want to use it, you can use the Payment Transfer Service. This enables you to transfer all your Direct Debits and standing orders from your old account to B over 3 months. Please note that the 7 working day switch guarantee does not apply to this service.",
    switchPageText5: '',
    switchPageText6: '',

    wantsToSwitch: 'Want to switch from your current account to B?',
    wantsToSwitchValidationMessage: 'This is required.',
    switchDetailsTitle: 'Your old current account details',
    switchAccountNameValidationMessage:
      'Your account name must be no more than 18 characters long.',
    switchAccountNameHelpMessage:
      'This is the name shown on your account statement.',
    switchAccountNumberValidationMessage: 'This must be 8 numbers long.',
    switchAccountNumberHelpMessage:
      'The account number will appear on your account statements.',
    switchSortCodeValidationMessage: 'This is 6 numbers long.',
    switchSortCodeHelpMessage:
      'You will see your sort code on your account statements, usually next to the account number.',
    switchHasDebitCardValidationMessage: 'Your 16-digit Card Number',
    switchDebitCardPanLabel: 'Your 16-digit Card Number',
    switchDebitCardPanValidationMessage: 'Your 16-digit Card Number',
    switchDebitCardPanHelpMessage:
      'This is the main number across the front of the card, typically printed in bigger characters and usually 16 numbers long.',
    switchDebitCardExpirationValidationMessage:
      'Please use numbers without any extra characters, so for example January 2017 should be written like this: 0117. The card must not have expired.',
    switchDebitCardExpirationHelpMessage:
      "This will be shown on the card as a month and year, typically next to a statement such as 'Expires end'.",
    switchTypeValidationMessage: 'This is required.',
    switchTypeTitle: 'Choose from two types of switch',
    switchTypeFullSwitch:
      'A full switch using the Current Account Switch Service will guarantee that once you have chosen and agreed the switch date with us the full balance and regular payments associated with your old account at your old bank will be switched to your new account and your old account will be closed. You will be advised of regular payments that cannot be automatically transferred and any payments made to your old account will be redirected to your new account.',
    switchTypePaymentSwitch:
      'The Payment Transfer Service allows you to choose which payments you would like to transfer across to your new account and your old account will not be closed. Please note that the 7 working day switch guarantee does not apply to this service.',
    switchDateValidationMessage:
      'The date cannot be in the past. Please remeber to select a date at least 7 working days from now, which is not a weekend or Bank Holiday.',
    switchDateHelpMessage:
      'This is the date you would like the switch to take place.',
    switchDateGuidance:
      'Please select a date at least 7 working days from now, which is not a weekend or Bank Holiday.',
    switchCloseOldAccount:
      'Yes, I agree to you closing my old current account when the switch to my new one is complete.',
    switchCloseOldAccountValidationMessage:
      'Please confirm your consent to continue.',
    switchCloseOldAccountHelpMessage:
      "This means that we'll transfer your balance, direct debits and standing orders before closing the account.",
    switchFullTsAndCsDocLink: 'static/switch-terms-' + brand.bankCode + '.pdf',
    switchFullTsAndCsDocLinkTitle:
      'Download Current Account Switch Service Terms & Conditions PDF. This link will open in a new browser window.',
    switchFullTsAndCsDocVersion: '1.0',
    switchFullTsAndCsText: 'Current Account Switch Service Terms & Conditions',
    switchAcceptFullTCs: 'Yes, I agree to the Terms & Conditions above',
    switchAcceptFullTCsValidationMessage: 'Please agree in order to continue.',
    switchPaymentsTsAndCsDocLink:
      'static/payment-transfer-' + brand.bankCode + '.pdf',
    switchPaymentsTsAndCsDocLinkTitle:
      'Download Payment Transfer Service Terms & Conditions PDF. This link will open in a new browser window.',
    switchPaymentsTsAndCsDocVersion: '1.0',
    switchPaymentsTsAndCsText: 'Payment Transfer Service Terms & Conditions',
    switchAcceptPaymentsTCs: 'Yes, I agree to the Terms & Conditions above',
    switchAcceptPaymentsTCsValidationMessage:
      'Please agree in order to continue.',
    // Switch page alt CYB content
    switchPageHeaderCYB: 'Switch',
    switchPageTitleCYB: 'Switch to us with the Current Account Switch Service',
    switchPageText1CYB:
      'If you have an agreed overdraft facility on your old account you will need to arrange a planned borrowing limit with us prior to switching your account to ensure that you can fully transfer any debit balance as part of your switch. You can arrange planned borrowing, subject to eligibility, just pop into your nearest branch or call us on 0800 678 3350.',
    switchPageText2CYB:
      "Switching your current account to us from another bank is straightforward with the Current Account Switch Service, we'll do everything for you. We'll contact your old bank so you don't have to worry about letting them know. The Current Account Switch Service is free to use and once you have chosen and agreed your switch date with us, we guarantee it will only take 7 working days, backed by the Current Account Switch Guarantee. On your switch date, your old account will be closed and all your payments and credit balance will be transferred to your new {bankName} account.",
    switchPageText3CYB:
      '<strong>Once your switch has started it cannot be stopped</strong>, but the guarantee means that if anything goes wrong we’ll refund any interest or charges made on either your old account or the new one as a result.',
    switchPageText4CYB:
      "If you're not eligible for the Current Account Switch Service, or you don't want to use it, the Payment Transfer Service lets you transfer your Direct Debits and standing orders from your old account to your new account over a 3 month period.",

    wantsToSwitchCYB:
      "If you want to use either of these switching services, please click on the 'Yes' button.",
    wantsToSwitchValidationMessageCYB: 'This is required.',
    switchDetailsTitleCYB:
      'Please fill in the following details. Use the details from the old account you’re switching from, and not the new one you’ve just opened.',
    switchAccountNameValidationMessageCYB:
      'Your account name must be no more than 18 characters long.',
    switchAccountNameHelpMessageCYB:
      'This is the name shown on your account statement.',
    switchAccountNumberValidationMessageCYB: 'This must be 8 numbers long.',
    switchAccountNumberHelpMessageCYB:
      'The account number will appear on your account statements.',
    switchSortCodeValidationMessageCYB: 'This is 6 numbers long.',
    switchSortCodeHelpMessageCYB:
      'You will see your sort code on your account statements, usually next to the account number.',
    switchHasDebitCardValidationMessageCYB: 'This is required.',
    switchDebitCardPanLabelCYB: 'Your 16-digit Card Number',
    switchDebitCardPanValidationMessageCYB:
      'This is the long number on the front of the card.',
    switchDebitCardPanHelpMessageCYB:
      'This is the main number across the front of the card, typically printed in bigger characters and usually 16-19 numbers long.',
    switchDebitCardExpirationValidationMessageCYB:
      'Please use numbers without any extra characters, so for example January 2017 should be written like this: 0117. The card must not have expired.',
    switchDebitCardExpirationHelpMessageCYB:
      "This will be shown on the card as a month and year, typically next to a statement such as 'Expires end'.",
    switchTypeValidationMessageCYB: 'This is required.',
    switchTypeTitleCYB: 'Please choose a switch option.',
    switchTypeFullSwitchCYB:
      'A full switch using the Current Account Switch Service will guarantee that once you have chosen and agreed the switch date with us that the full balance and regular payments associated with your old account will be switched to your new account and your old account will be closed. You will be advised of regular payments that cannot be automatically transferred and any payments made to your old account will be redirected to your new account.',
    switchTypePaymentSwitchCYB:
      'The Payment Transfer Service allows you to choose which payments you would like to transfer across to your new account, your old account will not be closed.',

    // Map Switch Response Codes to Messages
    switchCode000: 'Your switch has been successful',
    switchCode340:
      "Sorry. This account doesn't allow switching. But you can transfer your details from your old bank to B. Please call the team at B on " +
      brand.phoneNumber +
      ' for help.',
    switchCode365:
      "Sorry. This account doesn't allow switching. Please call the team at B on " +
      brand.phoneNumber +
      ' for help.',
    switchCode366:
      'The sort code, account number or 16-digit card number you’ve entered aren’t quite right. Please give them a double-check and try again.',
    switchCode364:
      "Sorry. You can't switch to this account at the moment. Please get in touch with the team at B.",
    switchCode367: "Sorry. You can't carry out a switch to B on this account.",
    switchCode345:
      "Switches can't go ahead on weekends and bank holidays. Please choose another date for your switch.",
    switchCode346:
      "Please pick a switch date that's at least 7 working days from now.",
    switchCode347:
      "Please pick a switch date that's less than 90 days from today, and more than 7 working days in the future.",
    switchCode393:
      'There’s been a problem with B, please try again later or call the team on ' +
      brand.phoneNumber +
      ' to get this sorted.',
    switchCode394:
      "Sorry. You can't switch to this account at the moment. Please get in touch with the team at B.",
    switchCode395:
      "There's been a problem with B, please try again later or call the team on " +
      brand.phoneNumber +
      ' to get this sorted.',
    switchCode349:
      "There's been a problem with B, please try again later or call the team on " +
      brand.phoneNumber +
      ' to get this sorted.',
    switchCode350:
      "Please check that the day, month and year you've given for your date of birth are correct. If they are then please get in touch with the team at B.",
    switchCode353:
      "Please pick a switch date that's at least 7 working days in the future.",
    switchCode380:
      "Sorry. You can't switch to B from this type of account. Please call the team at B on " +
      brand.phoneNumber +
      ' for help.',
    switchCode402:
      "Sorry. You can't switch to B from this type of account. Please call the team at B on " +
      brand.phoneNumber +
      ' for help.',
    switchCode403:
      "Sorry. You can't switch to B from this type of account. To switch you need an account that's backed by the Current Account Switch Service. Please call the team at B on " +
      brand.phoneNumber +
      ' to get something sorted.',
    switchCode398:
      "There's been a problem with B, please try again later or call the team on " +
      brand.phoneNumber +
      ' to get this sorted.',
    switchCode801:
      "There's been a problem with B, please try again later or call the team on " +
      brand.phoneNumber +
      ' to get this sorted.',
    switchCode355:
      "There's been a problem with B, please try again later or call the team on " +
      brand.phoneNumber +
      ' to get this sorted.',
    switchCode358:
      "There's been a problem with B, please try again later or call the team on " +
      brand.phoneNumber +
      ' to get this sorted.',
    switchCode359:
      "There's been a problem with B, please try again later or call the team on " +
      brand.phoneNumber +
      ' to get this sorted.',
    switchCode348:
      "Hold your horses - there's already a switch going on for this account.",
    switchCode861:
      "There's been a problem with B, please try again later or call the team on " +
      brand.phoneNumber +
      ' to get this sorted.',
    switchCode362:
      "There's been a problem with B, please try again later or call the team on " +
      brand.phoneNumber +
      ' to get this sorted.',
    switchCode363:
      "There's been a problem with B, please try again later or call the team on " +
      brand.phoneNumber +
      ' to get this sorted.',
    switchCode389:
      'B needs your postal address to continue, please call ' +
      brand.phoneNumber +
      '.',
    switchCodeDefault:
      'Sorry, something has gone wrong creating your switch application',

    // Authentication Page
    authPageHeader: 'Application',
    authPageSubtitle: 'Please login to continue',
    authPageTitle: 'Authentication',
    authFormTitle: undefined,
    authFormSubTitle: undefined,
    hasCustomerName: 'Do you have a customer number/username?',
    authChallengeSecurityQuestionValidationMessage:
      'This is the answer to the internet banking security question you selected at the time of registration. Please call us if you need help.',
    authPageContact:
      "If you need help with your application, or if any of your details aren't up-to-date, please call the team at B on " +
      brand.phoneNumber +
      '.',

    authBankQuestion: 'Please let us know where you have an account',
    authBankIdHelpMessage:
      'Please indicate the bank with which you hold an account',
    authFirstNameQuestion: 'First Name',
    authFirstNameHelpMessage:
      'Just using letters and spaces as it appears on your passport or driving licence.',
    authLastNameQuestion: 'Last Name',
    authLastNameHelpMessage:
      'Please use your last name as it appears in your passport or driving licence.',
    authGenderQuestion: 'Gender',
    authGenderHelpMessage: 'This is just to help identify you.',
    authDateOfBirthQuestion: 'Date Of Birth',
    authDateOfBirthHelpMessage:
      'Click on the month/year to start entering your dates. There’s no need to scroll. The date entered should be formatted DD-MM-YYYY.',
    authHouseNumberQuestion: 'House Number',
    authHouseNumberHelpMessage:
      'This is the number of your house or apartment.',
    authStreetQuestion: 'Street',
    authStreetHelpMessage:
      'Your street name should be written using number and letters only.',
    authPostcodeQuestion: 'Postcode',
    authPostcodeHelpMessage:
      'You need to supply a valid postcode for any UK address you add. These are normally formatted like this: A12 3BC.',
    authCheckDetailsError:
      'Can you check your details and try again please? Something went wrong but it might work if you try again.',
    authNextButtonText: 'Proceed',
    authFirstNameValidationMessage: 'Please use letters and spaces only.',
    authLastNameValidationMessage: 'Please use letters and spaces only.',
    authDateOfBirthValidationMessage:
      'Please enter a valid date in the following format DD-MM-YYYY.',
    authHouseNumberValidationMessage:
      'Sorry, your house number must be written using numbers and letters only and no longer than 40 characters.',
    authStreetValidationMessage:
      'Your street should be written using numbers and letters only and be no longer than 40 characters.',
    authPostcodeValidationMessage:
      'Please enter a valid postcode.  Postcodes are normally formatted like this - A12 3BC',
    authGenderValidationMessage: 'Please select a gender.',
    authPageLoadingMessage: 'Please wait while we load your details...',

    // Authentication Component
    authChallengeTitle: 'Stepup challenge',
    authChallengeSubtitle: '',
    telephoneAuthAccessCode: 'Telephone Access Code',
    telephoneAuthAccessCodeValidationMessage:
      'This is the 4-digit number you chose for Telephone Banking',
    telephoneAuthAccessCodeHelpMessage: 'This is 4 numbers long.',
    telephoneAuthSortCode: 'Sort code',
    telephoneAuthAccountNumber: 'Account number',
    debitCardAuthPan: 'Your 16-digit Card Number',
    debitCardAuthSortCode: 'Sort code',
    debitCardAuthAccountNumber: 'Account number',
    panHelpMessage:
      'This is the 16-digit card number that runs across the middle of the front of your card.',
    accessCodeHelpMessage:
      'This is your four-digit Access Account Number. It’s set during the registration process to allow you to access telephone banking and internet banking.',
    sortCodeHelpMessage:
      "You'll spot your 6-digit sort code on your bank statements and debit card.",
    accountNumberHelpMessage:
      '8-digit account number appears on your bank statements and debit card.',
    panValidationMessage: 'This is 16 numbers long.',
    accessCodeValidationMessage: 'This is 4 numbers long.',
    sortCodeValidationMessage: 'This is 6 numbers long without spaces.',
    accountNumberValidationMessage: 'This is 8 numbers long.',
    forgotPassword: 'Forgotten your password?',

    // Error Page
    errorPageHeader: 'Error',
    upgradeBrowserMessage:
      '<p class="browsehappy">Sorry, our online application does not support your browser. please <a href="http://browsehappy.com/" target="_blank" title="www.browsehappy.com This link will open in a new browser window.">update your browser <span class="screenreader">www.browsehappy.com This link will open in a new browser window.</span></a> to a newer version or try again with a different browser</p><p>You can close this window to return to the site to see other ways to apply.</p>',
    errorPageTitle: 'Sorry there has been a technical problem',
    errorPageText1: 'Something has gone wrong in the background.',
    errorPageText2:
      "While we're sorting it out, can you please call us instead on " +
      brand.phoneNumber +
      '. Lines are open Monday to Friday, 8am-8pm.',

    transactionsErrorBody:
      "Hmm. Looks like something's gone wrong in the background while loading your transactions. Why not give it another go?",
    transactionsErrorButtonTitle: 'Try again',

    // Setup in Progress Page
    setupInProgressHeader: 'Setup',
    setupInProgressTitle: "Sorry, there's been a slight technical hitch",
    setupInProgressText1:
      'Your account will be open and ready the next working day.',
    setupInProgressText2:
      "We'll let you know as soon as it's available so you can register for online banking, telephone banking and account switching.",
    setupInProgressText3: 'We look forward to being in touch very soon.',

    // Any page
    missingRequiredFields:
      'Please contact the team at B on ' +
      brand.phoneNumber +
      ' to add the information below and carry on with your application:',
    datePickerHelpMessageSuffix:
      'Click on the month/year to start entering your dates. There’s no need to scroll. The date entered should be formatted DD-MM-YYYY.',
    newBrowserWindowTitle: 'This link will open in a new browser window.',

    // Talk Panel
    talkLine: 'Call any time, day or night.',

    // Email Panel
    emailLine:
      'Send your feedback, but if you need a response please call instead. (Never email your bank details.)',

    // FAQ Panel
    faqLine: 'Find the answers right here.',

    // Demo Panel
    demoLine: 'See how the app works.',

    // About B Panel
    aboutBLine: 'Find out what you can do.',

    // T&C Panel
    tncLine: 'Want to have another look?',

    // feature2
    alertLandingPage: 'Manage your alerts',
    AboutBHead: 'About B',
    aboutBAccessibility1: 'You are on',
    aboutBAccessibility2: 'landing page',
    AboutBContent: 'Explore what B can do for you.',
    aboutB: 'About B',
    cheers: 'Cheers',
    earnInterest: 'Earn interest',
    earnInterestText: 'Current rates can be found at ',
    earnInterestLink:
      'https://www.youandb.co.uk/the-account/interest-rate-charges/',
    earnInterestLinkText:
      'www.youandb.co.uk/the-account/interest-rate-charges/',
    earnInterestData1: 'If you have any queries please call the team at B.',
    earnInterestData2:
      '** AER stands for Annual Equivalent Rate and illustrates what the interest rate would be if interest was paid and compounded each year. Gross rate is the interest payable without taking account of any tax payable.',
    getHelp: 'Get help',
    getHelpData:
      'If you need help or are unsure about anything get in touch on ',
    trackYourSpending: 'Track your spending',
    trackYourSpendingData:
      "Use Tags to find out how much you're spending, and Budgets to plan your spending from month to month.",
    overdraftText:
      'If you need some extra wiggle room, you can apply for an overdraft. Find all the details at ',
    overdraftLink: 'https://www.youandb.co.uk/the-account/your-overdraft/',
    overdraftLinkText: 'www.youandb.co.uk/the-account/your-overdraft/',
    overdraft: 'Get an overdraft if you need one.',
    overdraftData:
      "If you need some extra wiggle room, you can apply for an overdraft. Just don't forget you'll have to pay <strong>12.50% EAR<sup>††</sup></strong> on this. With a B overdraft, you get a £25.00 buffer and a two day grace period but if you go over these a £6.00 Monthly Planned Usage Fee will kick in on top of the interest.",
    overdraftData1:
      '<sup>††</sup> EAR mean Effective Annual Rate. This covers the rate and frequency of interest charged and the way it adds up (compounds) each year.',
    useyourtimeline: 'Use your timeline',
    useyourtimelineData:
      "Your timeline brings everything together, so you can easily keep an eye on the money that's coming in and out. And it gives you handy hints and tips the more you use your account.",
    freeAlerts: 'Set up free alerts',
    freeAlertsData:
      "So you always know when your money's running low in time to avoid charges.",
    projections: 'Projections',
    projectionsData:
      'Know in advance if your balance is due to run low to help you avoid missing payments.',
    sweeps: 'Sweeps',
    sweepsData:
      'Automatically move money between accounts when your balance reaches a certain amount.',
    createSavingPots: 'Create Savings Pots',
    createSavingPotsData:
      'Ideal if you have a goal in mind – like a holiday, or a new car – Savings Pots make it simple to save for the things you really want and move money around with a few taps.',
    statements: 'Get your statements online',
    statementsData: 'View and download your statements whenever you need them.',
    AboutBButton: 'Cheers',
    AboutBTableHead: 'Representative example',
    AboutBR1C1: 'Rate of interest',
    AboutBR1C2: 'Total amount of credit',
    AboutBR1C3: 'EAR<sup>††</sup>',
    AboutBR2C1: '11.84% per annum (variable)',
    AboutBR2C2: '£1200.00',
    AboutBR2C3: '12.50% variable',

    // Timeline Page
    timelineText: 'Your timeline',
    accountsText: 'Your accounts',
    mobileAccountText: 'Account List',
    mobileTimelineText: 'Timeline',
    accountBalanceUnavailable: 'Balance unavailable',
    accountTapToReload: 'Click to reload',
    accountBalanceCurrent: 'current',
    accountBalanceAvailable: 'available',
    NoSearchResult: 'These are all your account transactions at present',

    // Rename accounts
    renameAccountsLandingPageHeader: 'Rename accounts',
    renameAccountsLandingPageSubHeader:
      'Choose the account you want to give a nickname.',
    renameAccountHeader: 'Rename account',
    renameAccountSubHeader:
      "Give your account a nickname that you'll see on B on Web and the B app. Don't worry – it's only you that'll see it and it won't change on things like statements or cheque books.",
    renameAccountSuccess: 'Account name has been updated',
    renameAccountRestore: 'Change back to original account name',
    renameAccountNickname: 'Account nickname',

    // HelpPage
    helpPageTitle: 'HelpPage',
    HelpPageHeading: 'Help',
    helpPageError: 'We were unable to load your help at this time.',
    aboutTitle: 'About B',
    financialServices: 'Protecting your money',
    financialServices1: 'Financial Services',
    financialServices2: ' Compensation Scheme',

    // Popup
    PopupHeading: 'Opening in new window',
    HelpModelContent:
      'This link will open in a new window or tab and will take you out of B on Web.<br></br>If you like what you see and don’t come back in 5 minutes, you’ll be automatically logged out.',
    HelpPopupContent1:
      'This link will open in a new window or tab and will take you out of B on Web.',
    HelpPopupContent2:
      'If you don’t come back in 5 minutes, you’ll be automatically logged out.',
    // AnyquestionsURL

    anyQuestionURL: 'https://www.youandb.co.uk/help/b-help/',

    prefrenceUrl: 'https://www.youandb.co.uk/help/b-help/',

    anyQuestionURLForLimits: 'https://www.youandb.co.uk/help/b-help/',

    // Talk Popup
    TalkHead: 'Calling the team at B',
    TalkData:
      'Call <strong>0800 121 7365</strong> for free any time, day or night - from your landline or your mobile.',
    TalkData1:
      "If you're calling from abroad, call +44 141 221 7300, though local providers may charge you for the call.",
    TalkData3:
      "Call <strong>0800 345 7365</strong> for free any time, day or night - from your landline or your mobile.<p><small>If you're calling from abroad, call +44 141 951 7320, though local providers may charge you for the call.</small></p><p>Currently on a call with one of our advisers?<a>Securely share your screen</a> to get live help.</p>",
    TalkButton: 'Back to help',
    TalkMobileData:
      'Call <a href="tel:0800 121 7365">0800 121 7365</a> for free any time, day or night - from your landline or your mobile.',
    TalkMobileData1:
      'If you\'re calling from abroad, call <a href="tel:+44 141 221 7300">+44 141 221 7300</a>, though local providers may charge you for the call.',
    TalkHeader: 'Talk',

    // Email
    EmailHeader: 'Let us know what you think',
    EmailContent:
      'Something to share? Get in touch by email – just remember never to send your bank details.',
    EmailContent2:
      'Email’s mainly used for feedback, so if you need an answer right away, check out the FAQs or give the team at B a call.',
    EmailFooter: '(Never email your bank details.)',
    EmailHead: 'Email is just for feedback right now',
    HelpEmailHead:
      "If you'd like to email what you think of things so far please do. Your thoughts could help make B even better. Just remember, never give your bank details by email.",
    EmailBody:
      'If you need a response, check out Any questions? in Help.<br/> Or, give the team at B a call on 0800 121 7365.',
    EmailButton1: 'Go back to Help',
    EmailButton2: 'Give Feedback',
    FeedbackEmail: 'hellob@cybg.com',
    EmailSubjectLine: 'My Feedback',
    EmailBody1:
      'If you need a response, check out Any questions? in Help.<br/> Or, give the team at B a call on  <a href="tel:0800 121 7365">0800 121 7365</a>.',

    // Feedback
    feedbackHeader: 'Something to share?',
    feedbackContent:
      'Share your thoughts on B on Web by emailing the team at B – just remember never to send your bank details.',
    sendFeedback: 'Send feedback',

    // Your Support
    yourSupportHeader: 'Your Support',
    yourSupportContent:
      "If you're experiencing something that affects how you bank with us, we can support you, whether it be temporary or long-term health concerns, accessibility needs or money worries.",

    // Lost cards
    LostCardHeader: 'Report a card lost or stolen',
    LostCardContent:
      'Get in touch as soon as you can on <strong>0800 121 7365</strong>. For more info, check out the ',
    LostCardContentFaq: 'FAQs',
    LostCardContentDot: '.',
    // Any Questions

    FaqDone: 'Done',
    AnyquestionTitle: 'Any questions?',
    anyQuestionsContent: 'Find the answers right here.',
    anyQuestionsHeading: 'Any questions?',
    // AnyquestionTitle1: 'questions?',

    // Chat
    chat: 'Want to chat?',
    chatContent:
      '<p><strong>Launch live chat to talk to the team at B.</strong></p><p>The team at B will keep chat transcripts for training, legal and compliance reasons.</p>',

    // Call us
    callTitle: 'Talk',
    callTitleBusiness: 'Busines User',
    // callContent : 'Call the internet banking helpdesk on 0800 121 7365 for free any time, day or night. - from your landline or mobile.<p>If you’re calling from abroad, call +44 141 221 7300, though local providers may charge you for the call.</p>',
    callContent1:
      'Call 0800 121 7365 for free any time, day or night – from your landline or mobile. Calling from abroad? It’s +44 141 221 7300.',
    callContent2: 'On a call with the team at B right now? Securely ',
    callContent3: 'share your screen',
    callContent4: ' with them to get their help.',

    // Terms&Conditions
    TermsCondition: 'T&Cs',
    TnCHeading: 'Terms & Conditions',
    TermsConditionPageTitle: 'T&Cs',
    DownloadTermsCondition: 'Download our T&Cs',
    TCHead:
      "It's kind of boring. But here it is, if you'd like to take another look.",
    TCData: 'The terms and Conditions for the B app',
    TCData1: 'B app background',
    TCData2:
      "B is designed to be an intuitive digital banking sevice built into an app. It's available on compatible tablets and compatible mobile phones and has lots of smart tools, evolving as it learns, to help you take care of your money.",
    TCData3:
      "You will need a both a compatible tablet and a compatible mobile phone to take full advantage of all features of the B app, though other mobile phones can still be used to receive SMS alerts. B accounts can't be used for Business purposes. B can be supported by a B Current account and B Instant Savings account or any other account we agree it can be used with.",
    TCData4:
      'The B accounts and services are provided by Clydesdale Bank PLC and Yorkshire Bank (which is trading name of Clydesdale Bank PLC).',
    TCData5:
      'When we refer to the "team at B", "we", "us" and "our"; we are referring to Clydesdale Bank PLC.',
    TCButton: '<strong>Back to help</strong>',

    // Protected
    BankUrl: 'https://www.youandb.co.uk/the-account/fscs/',
    // Protected Panel
    protectedLine:
      'Find out how eligible deposits are protected by the Financial Services Compensation Scheme.',
    ProtectedTitle: 'Protecting your money',
    // ProtectedTitle1: 'your money',

    // Demo Page
    Demo: 'Demo',
    DemoContent: '[See how key features work]',
    DemoSkipButton: 'Skip',
    BImg: 'Click on the arrows to see what B can do',
    TimelineImg:
      "See what's happening in all your accounts in one place. And in real time too.",
    InsightsImg:
      "Look at the tiles on the screen for handy insights into how you're spending your money.",
    TaggingImg:
      'Most of your transactions are tagged automatically with handy labels. You can change tags around and create your own too.',
    SpendingImg:
      'Take control of your money by setting budgets and tracking your tagged spend.',
    SavingsPotsImg:
      'With Savings Pots you can put away a little or a lot, whatever works for you. Every penny gets you closer to achieving your goals.',
    PaymentsImg: 'Pay anyone and make transfers easily.',
    AlertsMessagesImg: "Set up text alerts so you're always one step ahead.",
    SweepsImg:
      "Set up Sweeps to automatically move money from your B Savings account and receive texts when you're running low.",
    ProjectionsImg:
      "Look ahead and keep track of projected earnings and commitments, and receive alerts if you're going to run low.",
    HelpImg: "If you're stuck at any point just go to Help.",

    // Demo Page Ready? Go
    DemoReadyGo: 'Ready? Go',
    DemoDone: 'Done',

    // TimeLine Page
    nbaHeaderData: 'Why not add a credit card to your account?',
    nbaDisplayData:
      'if you need to buy something expensive that you cant afford to pay for all at once, a credit card is ideal.If you dont have the cash to hand-or even in your bank account-you can pay with a credit card and then spread the cost over over a number of months.',

    // feature 4
    // Financial Stories & Projection
    MicroTransaction: 'microTransactions',
    Cashpoint: 'cashpoint',
    InAndOut: 'insAndOuts',
    Projection: 'projection',
    Showing: 'Showing',
    Upto: 'up to',
    CurrencySign: '-£',
    accountDetailsInprogressHeader: 'In progress',
    accountDetailsInprogressContent: 'This is still going through',
    inAndOutFootrText: 'You had {credit} come in,\nbut {only} {debit} go out.',
    inAndOut_headerTextCurrentMonth:
      "Nothing's gone in or out\nof your account so far",
    inAndOut_headerTextOtherMonths: 'Nothing went in or out\nof your account',
    inAndOut_headerTextCurrentMonthPositiveSum: "So far you're up {sum}",
    inAndOut_headerTextCurrentMonthNegativeSum: "So far you're down {sum}",
    inAndOut_headerTextOtherMonthsPositiveSum: 'You were up {sum}',
    inAndOut_headerTextOtherMonthsNegativeSum: 'You were down {sum}',
    cashpoint_headerTextCurrentMonth: "You haven't taken out\nany cash so far",
    cashpoint_headerTextOtherMonths: "You didn't take out any cash",
    cashpoint_headerTextCurrentMonthSum:
      "You've taken out {sum} in cash so far",
    cashpoint_headerTextOtherMonthsSum: 'You took out {sum} in cash',
    cashpoint_footerText: 'You usually take out {sum} at a time.',
    noTransactionMessage:
      "Sorry but it's not possible to show payments for this account type.",
    noTransactionFound: 'No transactions found',
    takeLookAtFaq: 'Take a look at our FAQs',
    transactionReTag: '{TranNo} transaction has been retagged {TagName}',
    transactionReTags: '{TranNo} transactions have been retagged {TagName}',
    transactionUnTag: '{TranNo} transaction has been untagged',
    transactionUnTags: '{TranNo} transactions have been untagged',
    transactionGridMessage:
      "That's all we can find. Try changing your date range?",
    transactionGridMobileMessage: "That's all we can find.",
    transactionRefundDetails:
      'The merchant has confirmed that your refund is being processed. We’ll show the refund in your balance once we’ve received it. Any questions?',
    transactionRefundFaqLink:
      'https://uk.virginmoney.com/service/debit-card-refunds/',
    transactionRefundNotInBalance:
      'This won’t show in your balance yet - find out more',
    micro_headerTextCurrentMonth:
      "So far you haven't paid\nfor anything under a tenner",
    micro_headerTextOtherMonths: "You didn't pay for\nanything under a tenner",
    micro_headerTextCurrentMonthWithSum:
      "So far you've spent {sum} on things under a tenner",
    micro_headerTextOtherMonthsWithSum:
      'You spent {sum} on things under a tenner',
    micro_footerText: "That's about {sum} a pop.",
    currency: 'GBP',
    asc: 'asc',
    desc: 'desc',
    threeMonths: '3 months',
    customRange: 'Custom Range',
    transactionListViewError:
      'We were unable to load your transactions at this time. Please try again later or pull down to try again now',

    // Account Details
    availableBalance: 'Available balance',
    borrowingLimit: 'Planned borrowing limit',
    lastStatementDate: 'Last statement date',
    lastStatementBalance: 'Last statement balance',
    minPaymentDue: 'Minimum payment due',
    paymentDueDate: 'Payment due date',
    creditCardLimit: 'Credit card limit',
    AccountMoreInfoView_AvailableBalanceDisclaimer:
      "This balance may also include items that haven't gone through yet.",
    AccountMoreInfoView_AvailableBalanceDisclaimer_WithOverdraft:
      "This balance, which includes any overdraft, may also include items that haven't gone through yet.",
    AccountMoreInfoView_ContactMessage:
      "If you'd like to talk about this account, please call the team at B on 0800 1217365.",
    prevSlide: '◀︎',
    nextSlide: '▶︎',
    helpButton: 'Help',
    searchKey: 'Search',
    yesText: 'Yes',
    FYI: 'FYI',
    transition: 'scale',
    current: 'current',
    creditCard: 'credit_card',
    savings: 'savings',
    loan: 'loan',
    mortgage: 'mortgage',
    moreInformation: 'More information',
    hideInformation: 'Hide Information',
    dateRangeVallidationMsg:
      'Something’s not right there. Make sure the date you’ve entered is less than five years ago and before the date you want to view your transactions up to.',
    todateRangeVallidationMsg:
      'Something’s not right there. Make sure the date you’ve entered isn’t in the future or before the date you want to view your transactions from.',
    chooseDateValidationMsg:
      'Choose the date range you want show. This should be entered as DD/MM/YYYY.',
    applyFilter: 'Apply Filter',

    // Account View
    accountCardBalanceText:
      'This balance may also include items that haven’t gone through yet. <br />If you’d like to talk about this account , please call the team at B on 0800 1217365',
    availableBalanceExpalanationText:
      "Your available balance includes pending transactions, so it shows what you've got available right now.",
    availableBalanceWithOverdraftExpalanationText:
      "Your available balance includes pending transactions, so it shows what you've got available right now. Got an overdraft? That'll be included here too.",
    HCCRavailableBalanceExpalanationText:
      "Your balance shows pending transactions, including any cheques that haven't cleared yet.",
    HCCRavailableBalanceWithOverdraftExpalanationText:
      "Your balance shows pending transactions, including any cheques that haven't cleared yet. Got an overdraft? You'll see it on its own.",
    clearedBalanceExplanationText:
      'This is your current balance excluding any cheques that haven’t cleared yet. When a cheque clears, it’ll be included here – but it may still be returned unpaid by the bank it came from.',
    accountBalanceContactUs:
      'Want to talk about this account? Get in touch with the team at B.',

    // tag
    deleteTagHeader: 'Delete this tag?',
    deleteTagContent:
      "You'll still be able to see it on your transactions, but you won't be able to use it in the future. Still happy to delete?",
    tagInfoPopupHeader: 'Tags',
    tagInfoPopupContent:
      'Now choose one of the Tags from this list or tap on My Tags to create one of your own (you can have up to 5).',
    tagSidebarHeading: 'Choose your transactions',
    tagSidebarContent:
      'Start by choosing the transaction(s) you want to tag, selecting one type only (like Groceries or Fuel).',
    rememberThisTagContent:
      "'Remember this' enables you to tag every transaction like this in the future.",
    rememberThis: 'Remember this',
    addNewTagModal: 'Add a new tag',
    menuTitle: 'Menu',
    closeButton: 'Close',
    editButton: 'Edit',
    myTagsHeader: 'My Tags',
    unTagSelected: 'Untag Selected',
    tagCreateUpdatError:
      'When contacting support, please quote ID : {quote-id}',
    addTag: 'Add Tag',
    selected: 'Selected',
    // Digital Statements
    IEPrintIssueModalHeading: 'Your browser isn’t supported', // only for IE case
    IEPrintIssueModalBody1:
      'Sorry, due to some technical issues, you’re not able to download or print online statements using Internet Explorer. Please use another browser to download or print your statement.',
    IEPrintIssueModalBody2:
      'If you do not have access to another browser we do not recommend that you turn off paper statements. For more information, ',
    IEPrintIssueModalBody3:
      'Sorry, due to some technical issues, you’re not able to download or print online statements using Internet Explorer. Please use another browser to download or print your statement. For more information, ',
    checkoutFAQ: 'check out the FAQs.',
    digitalStatementTileContent:
      'View and download your statements whenever you need them.',
    statementSuccess: 'Great, your statement preferences have been updated',
    gotoStatements: 'Go to your Statements',
    statementPreferences: 'Statement preferences',
    statementPreferencesModalHeader: 'All you need to know',
    updateStatementPreferencesModalHeader: 'All you need to know',
    digitalModalButton: 'Got it',
    digitalModalHeader: 'All you need to know',
    digitalModalHeader1: 'View your statements whenever you need them',
    digitalModalHeader2: 'Download and print your statements',
    digitalModalHeaderContent1:
      'You can now view statements for B, Clydesdale Bank and Yorkshire Bank accounts right here in B. Some types of accounts aren’t currently able to display online statements.',
    digitalModalHeaderContent2:
      'If you notice your online statement looks a little different from your regular paper statement, don’t worry. Your online statement has been stripped back a little, so it’ll only have the essential information you really need.',
    digitalModalHeaderContent3:
      'You can go ahead and download and print your statements straight from your mobile, tablet or computer.',
    digitalModalHeaderContent4:
      "Need to show your statement as proof of address? You might be able to use your online statement, but it really depends on the company you're showing it to. Some accept PDFs or printed copies of online statements – others need to see original, paper statements.",
    digitalErrorMessage1:
      'There’s been a problem loading your statement, please try again later.',
    digitalErrorMessage2: 'When contacting support,',
    digitalErrorMessage3: 'please quote ID: ',
    digitalQuoteID: 'b21ddf',
    // Statement Preferences

    statementPreferenceHeading: 'Your statements, your way',
    backToAccounts: 'Back to accounts',
    goPaperfreeLine1: 'Go paper-free to only get statements in B*.',
    goPaperfreeLine2: 'Or keep paper statements to get them in',
    goPaperfreeLine3: 'the post too.',
    statementPreferenceGotAccountHeader: "Got an account that isn't here?",
    statementPreferenceGotAccountBody1:
      "Some types of accounts aren't currently able to",
    statementPreferenceGotAccountBody2: 'receive paperless statements.',
    statementPreferenceGotAccountInfo1:
      '*Device and browser restrictions may apply.',
    statementPreferenceGotAccountInfoLink1: ' Find out more in our FAQs.',
    statementPreferenceGotAccountInfo2:
      'There may be some problems downloading or printing online statements on certain combinations of devices and browsers. You can',
    statementPreferenceGotAccountInfoLink2: ' find out more in our FAQs.',
    paperfree: 'Paper-free',
    paper: 'Paper',
    statementPrefernceModalHeader1: 'Going paper-free? Great.',
    statementPrefernceModalHeader2: 'Still want paper statements? That’s fine.',
    statementPreferenceModalContent1:
      "You can access online versions of your statements whenever you need them by logging in to B and going to your account. They'll be updated every month and they'll be in the same format as you’re used to.",
    statementPreferenceModalContent2:
      'You’ll still get some documents, like annual summaries, in the post. And if there are any fees or charges you need to know about, you’ll still get a paper statement for the time being.',
    statementPreferenceModalContent3:
      'Got a joint account? If you go paperless, make sure the other account holder is happy not to receive paper statements.',
    statementPreferenceModalContent4:
      'Currently get your statements in Braille, large print or audio? Or have other special arrangements for your paper statements? If you go paperless, you’ll no longer get them.',
    statementPreferenceModalContent5:
      'If the team at B have already started printing your statement, you’ll still get it in the post.',
    statementPreferenceModalContent6:
      'You can go ahead and download and print your statements straight from your mobile, tablet or computer (only if you have access to a printer, obviously).',
    statementPreferenceModalContent7:
      'If you ever need a paper statement in the future, just get in touch with the team at B.',
    statementPreferenceModalContent8:
      'Miss all that paper? You can go back to paper statements at any time by changing your statement preferences.',
    statementPreferenceModalContent9:
      "You'll get all your statements in the post - just like you used to.",
    statementPreferenceModalContent10:
      "If you're changing from paper-free to paper statements, your preferences will be updated soon (if this month's statements have already been processed, you'll get paper statements in the post from next month).",
    statementPreferenceModalContent11:
      "By hitting 'Continue', you're confirming that you understand and agree to the above, and your preferences will be changed.",
    statementPreferenceModalContent12:
      'There may be some problems downloading or printing online statements on certain combinations of devices and browsers. You can',
    statementErrorHeader:
      'Oops, theres been a problem updating some of your statement preferences, please try again later',
    statementContinue: 'Continue',
    // sweeps
    sweepLine1: 'In my',
    sweepLine2: 'when I have <strong>less</strong> than',
    sweepLine3: '<strong>sweep</strong> money from',
    sweepLine4: 'to meet my target of',
    triggerEntryViewController_TermsOfUse_SingleAccount:
      'You can set up Sweeps to move money from your B Instant Savings account to your B Current Account. They can help you avoid charges but remember, they’re just automatic transfers, so will only work if there is enough money in your B Instant Savings account - e.g. you can set up a 					Sweep to add £150 to your B Current Account every time it gets below £50 but it will only sweep that if you have the £150 in your B Instant Savings account. Make sense? They can take a teeny bit of time to show on your account but you’ll get a text each time a Sweep happens, 				even if it’s at the weekend. And you can change your Sweep settings at any time.',
    infoPopupContentForJointAccountHolder:
      'Low balance sweeps are automatic transfers from our chosen B Instant Savings account to our joint B Current account. One of us can set up sweeps to avoid charges and make payments when my current account runs low (drops below the lower balance trigger)										  .However, sweeps can only work if there is enough money in our chosen savings account. If there isn’t, the sweep may not be able to reach the joint account’s lower target balance and the account will be charged. Sweeps can happen several times a day 										  (including weekends).\n\nEvery time there’s a sweep both joint account holders will get a text to let them know what’s happening. Likewise when one of you edits sweep settings, both joint account holders will be made aware of the change.',
    infoPopupContent:
      'Low balance sweeps are simply automatic transfers from my B Instant Savings account to my B Current account. I can set up sweeps to avoid charges and make payments when my current account runs low (drops below my lower balance trigger). However, sweeps can only work if there is enough money in my savings account. If there isn’t, the sweep may not be able to reach my lower target balance and I may have to pay charges. Sweeps can happen several times a day (including weekends). Each time there’s a sweep I’ll get a text to let me know what’s happening. I can change the settings any time I like within B.',
    infoPopupHeader: 'User agreements',

    infoPopupButton: 'OK, I understand',
    deletePopupHeader: 'Delete',
    deletePopupContent: 'Are you sure you want to delete this sweep?',
    okButton: 'OK',
    deleteSweep: 'Delete Sweep',
    sweepCreationPopup: 'Your sweep has been created',
    sweepUpdatePopup: 'Your sweep has been updated',
    sweepDeletePopup: 'Your sweep has been deleted',
    sweepNotDeletePopup: 'Sweep not found',
    doneButton: 'Done',
    editMySweep: 'Edit my sweep',
    createMySweep: 'Create my Sweep',
    createMySweepNewUser: 'Create a sweep',

    // Alerts&Sweeps page
    alertSweepTitle: 'Alerts & Sweeps',
    alertsSweepsHead: 'Alerts & Sweeps',
    wbaMessage:
      "Keep track of your money with weekly text updates that tell you how much you've got left in your account.",
    alertMessage:
      'Set up alerts to receive text messages when you reach a certain amount on your chosen account.',
    sweepMessage:
      'Set up sweeps to be notified when your threshold is reached and select the account you want your money to be swept from to meet your target balance.',
    alerts: 'Alerts',
    errorMessage: 'Something techie has gone wrong. Please try again.',
    cancelButton: 'Cancel',
    confirmButton: 'Confirm',
    confirmButtonSweep: 'Create sweep',
    wba: 'Balance updates',
    confirmButtonUpdate: 'Create alert',
    confirmButtonAlert: 'Create alert',

    continueButton: 'Continue',
    infoButton: 'Info',
    deleteButton: 'Delete',
    createSweep: 'Create sweep',
    createUpdate: 'Create a weekly balance update',
    editMyUpdate: 'Edit my weekly balance update',
    editSweep: 'Edit Sweep',
    createAlert: 'Create alert',
    AlertSweep: 'Alert and sweep.',
    footerLabelSweep:
      'Just so you know, you might still get one more balance sweep from us.',
    footerLabelAlert:
      'Just so you know, you might still get one more balance alert from us.',
    footerLableWBA:
      'Just so you know, you might still get one more alert from us.',
    footerLabelJointAccountHolder:
      'This sweep was set up by your joint account holder. You can’t edit it, but you can give them a nudge to do it',
    maxSweepPopupHeader: 'An alert about your sweeps',
    maxWBAPopupHeader: 'Your balance updates',
    maxSweepPopupData:
      'You can only have one low balance sweep per account. But you can edit your existing sweeps.',
    appErrorForAlerts:
      'We were unable to load your alerts or sweeps at this time.',
    alertSweepValidationMsg:
      'Oops. You’ll have to enter an amount here to continue.',
    //	triggerDashboardViewController_Failure_Details_Text: 'We were unable to load your alerts at this time. Please try again later',
    //	failedToLoadSweeps: 'We were unable to load your sweeps at this time. Please try again later',
    //	failedTpLoadAlertsNSweeps: 'We were unable to load your alerts or sweeps at this time. Please try again later',
    triggerDashboardViewController_NoEligibleAccounts_Title:
      'No available accounts', // not used
    triggerDashboardViewController_NoEligibleAccounts_Alerts:
      'To use alerts, you need to open an account which supports them.', // not used
    triggerDashboardViewController_NoEligibleAccounts_Sweeps:
      'To use sweeps, you need to open an account which supports them.', // not used
    triggerDashboardViewController_NoEligibleAccounts_AlertsSweeps:
      'To use alerts or sweeps, you need to open an account which supports them.', // not used
    triggerDashboardViewController_NoEligibleAccounts_ButtonTitle: 'Retry', // not used
    triggerDashboardViewController_CantCreateTrigger_Title:
      'Server unavailable', // to ask
    triggerDashboardViewController_CantCreateTriggerAlert_Message:
      'Can’t create any alert', // to ask
    triggerDashboardViewController_CantCreateTriggerSweep_Message:
      'Can’t create any sweep', // to ask
    triggerEntryViewController_ThresholdAmount_Minimum_Error_Message:
      'Threshold amount has to be at least 0 pounds.', // to ask
    triggerEntryViewController_TargetAmount_Minimum_Error_Message:
      'Target amount has to be at least 100 pounds.', // to ask
    triggerEntryViewController_TargetAmount_Error_Message:
      'Target amount has to be at least 100 pounds larger than the threshold amount.',
    triggerListCell_lowerThresholdAlert_Title_Prefix: 'Low balance alert',
    triggerListCell_projectionThresholdAlert_Title_Prefix:
      'Projection low balance alert', // differ
    triggerListCell_upperThresholdAlert_Title_Prefix: 'High balance alert',
    triggerEntryViewController_ending: 'ending',
    projectionLowBalanceAlert: 'Projection balance Alert', // removed low word
    sweepAlert: 'Sweep alert',
    jointAccountHolders: 'Joint Account Holders',
    confirmChanges: 'Confirm changes',

    projection404Title:
      'See in advance how the rest of your month is panning out.',
    projection404Subtitle: 'Set up Projections',

    projection409_0Title:
      "You're all set up, now B's just crunching the numbers.",
    projection409_0Subtitle: 'Calculating...',

    projection409_1Title:
      "B doesn't have enough to go on at the moment - please try again soon.",
    projection409_1Subtitle: 'Try again soon',
    projection409_1NotEnoughData: '##days## days left...',
    projection409_1NotEnoughDays: '##days##',

    projection409_2Title:
      "Your preferences have been updated, B's just crunching the numbers.",
    projection409_2Subtitle: 'Calculating...',

    projection500Title: 'There was an error retrieving your Projection',
    projection500Subtitle: 'Please try again later',

    projection200GoodTitle:
      "Great news, looks like you'll be in the green 'til payday.",
    projection200GoodSubTitle: 'Go to Projections',

    projection200BadTitle:
      "You're running low - top up to ensure your bills get paid.",
    projection200BadSubtitle: 'Review Projections',
    // projectionInformation :'When I am projected to have <strong>{lessMore}</strong> than <strong>£{thresholdAmount}</strong> in my <strong>{accountName}</strong> please send me a text.',

    // Alerts
    // WBA
    createAnUpdate: 'Create a balance update',
    wbaTitle: 'Weekly balance update',
    alertCreationPopup: 'Your alert has been created',
    alertUpdatePopup: 'Your alert has been updated',
    createMyAlertNewUser: 'Create an alert',

    createMyAlert: 'Create my Alert',
    editMyAlert: 'Edit my alert',
    inMy: 'In my',
    whenIHave: 'when I have',
    than: 'than',
    send: '<strong>send</strong> me an alert via',
    sms: 'SMS',
    maxAlertPopupHeader: 'An alert about your alerts',
    maxAlertPopupData:
      'You can only have one high and one low balance alert per account. But you can edit your existing alerts.',
    maxWBAPopupData:
      'You can only set up one weekly balance update per account. But you can go ahead and edit your existing balance updates if you need to.',
    // Projection
    projectionLine2: 'when my projected balance is <strong>below</strong>',
    projectionLine3: '<strong>send</strong> me an alert via',
    projectionLine4: '<strong>SMS</strong>',
    projectionUpdationPopup: 'Your alert has been updated',
    // ProjectionFinancialStoryPreviewCell
    projectionFinancialStoryPreviewCellTitleNotEnabled:
      'See in advance how the rest of your month is panning out.',
    projectionFinancialStoryPreviewCell_SubTitle_NotEnabled:
      'Set up Projections',
    projectionFinancialStoryPreviewCellTitleNotEnoughData:
      "B doesn't have enough to go on at the moment - please try again soon",
    projectionFinancialStoryPreviewCell_SubTitle_NotEnoughData:
      '##days## days left...',
    projectionFinancialStoryPreviewCellSubTitleNotEnoughDataDays: '##days##',
    projectionFinancialStoryPreviewCellSubTitleNotEnoughDataBackupTitle:
      'Try again soon',
    projectionFinancialStoryPreviewCellTitleProjectionInProgress:
      "You're all set up, now B's just crunching the numbers",
    projectionFinancialStoryPreviewCellSubTitleProjectionInProgress:
      'Calculating...',
    projectionFinancialStoryPreviewCellTitleProjectionUpdatingPreferences:
      "Your preferences have been updated, B's just crunching the numbers.",
    projectionFinancialStoryPreviewCellSubTitleProjectionUpdatingPreferences:
      'Calculating...',
    projectionFinancialStoryPreviewCellTitleGoodProjectionResult:
      "Great news, looks like you'll be in the green 'til payday.",
    projectionFinancialStoryPreviewCellSubTitleGoodProjectionResult:
      'Go to Projections',
    projectionFinancialStoryPreviewCellTitleBadProjectionResult:
      "You're running low - top up to ensure your bills get paid.",
    projectionFinancialStoryPreviewCellSubTitleBadProjectionResult:
      'Review Projections',
    projectionFinancialStoryPreviewCellTitleProjectionError:
      'There was an error retrieving your Projection',
    projectionFinancialStoryPreviewCellSubTitleProjectionError:
      'Please try again later',

    // ProjectionsExpandedView (View which gets updated when wheel spin)
    projectionsExpandedViewControllerProjectionsSettings: 'Projection Settings',
    projectionsExpandedItemViewYoureGoodToGoBalanceHeading:
      "B predicts you're good to go. You should have",
    projectionsExpandedItemViewThisIsMadeUpOfSubHeading:
      'before your next earning. This is made up of',
    projectionsExpandedItemViewThisIsMadeUpOfWthin31DaysSubHeading:
      'over the next 31 days. This is made up of',
    projectionsExpandedItemViewCurrentBalance: 'Current Balance',
    projectionsExpandedItemViewCommitments: 'Commitments',
    projectionsExpandedItemViewTomorrowsEarnings: "Tomorrow's earnings",
    projectionsExpandedItemViewEssentialSpend: 'Essential spend',
    projectionsExpandedItemViewLowBalanceLimit: 'Low balance limit',
    projectionsExpandedItemViewSpinTheWheelFootNote:
      'Spin the wheel to find out more',
    projectionsExpandedItemViewSpinTheWheelToSeeTheFutureFootNote:
      'Spin the wheel to see what the future may look like',
    projectionsExpandedItemViewYourCurrentBalanceHeading:
      'Your current balance is',
    projectionsExpandedItemViewThisMayDifferFootNote:
      'This might be different to your available balance\n(you can check this in your account screen)',
    projectionsExpandedItemViewYouHaveXCommitmentsPart1Heading: 'You have',
    projectionsExpandedItemViewYouHaveXCommitmentsPart2Heading:
      'commitments. These come to',
    projectionsExpandedItemViewYouHaveOneCommitmentHeading:
      'You have 1 commitment. This comes to',
    projectionsExpandedItemViewYouHaveNoCommitmentsHeading:
      'You have no commitments',
    projectionsExpandedItemViewYouHaveXCommitmentsWithin31DaysPart2Heading:
      'commitments. These come to',
    projectionsExpandedItemViewYouHaveOneCommitmentWithin31DaysHeading:
      'You have 1 commitment. This comes to',
    projectionsExpandedItemViewYouHaveNoCommitmentsWithin31DaysHeading:
      'You have no commitments',
    projectionsExpandedItemViewYouveTaggedHeading: "You've tagged",
    projectionsExpandedItemViewAsEssentialSpendSubHeading:
      'as essential spend. Your top tags are',
    projectionsExpandedItemViewSingagEssentialSpendSubHeading:
      'as essential spend. Your tag is',
    projectionsExpandedItemViewNoTagsAsEssentialSpendSubHeading:
      'You have no essential spend',
    projectionsExpandedItemViewAsEssentialSpendWithin31DaysSubHeading:
      'as essential spend. Your top tags are',
    projectionsExpandedItemViewSingagEssentialSpendWithin31DaysSubHeading:
      'as essential spend. Your tag is',
    projectionsExpandedItemViewNoTagsAsEssentialSpendWithin31DaysSubHeading:
      'You have no essential spend',
    projectionsExpandedItemViewYourNextEarningHeading:
      'The next cash coming into your account should be',
    projectionsExpandedItemViewNoNextEarningHeading:
      'There is no cash coming into your account in the next 31 days',
    projectionsExpandedItemViewTomorrowsEarningHeading:
      'You have cash coming in tomorrow',
    projectionsExpandedItemViewTomorrowsEarningRunningLowSubHeading:
      'but it looks like you may still run low',
    projectionsExpandedItemViewYouCanChangeThisFootNote:
      'You can change this in Projection Settings',
    projectionsExpandedItemViewYouCanChangeTheseFootNote:
      'You can change these in Projection Settings',
    projectionsExpandedItemViewYouCanManageThisFootNote:
      'You can manage this in Projection Settings',
    projectionsExpandedItemViewYouCanManageTheseFootNote:
      'You can manage these in Projection Settings',
    projectionsExpandedItemViewYouCanReviewThisFootNote:
      'See this in Projection Settings',
    projectionsExpandedItemViewYouCanViewThisFootNote: 'See this below',
    projectionsExpandedItemViewYouCanViewTheseFootNote:
      'See what these are below',
    projectionsExpandedItemViewWarningPart1Heading:
      "Looks like you'll go below your\nlow balance limit of",
    projectionsExpandedItemViewWarningPart2Heading: 'on',
    projectionsExpandedItemViewProjectedIn: 'This is projected in ',

    // Projection Screen
    projectionSummaryHeaderNoWarningDays:
      "B predicts you're good to go. You should have",
    projectionSummaryHeaderWarningDays:
      "Looks like you'll go below your low balance limit of {amount} on",
    projectionSummaryFooter: 'Spin the wheel to find out more',
    projectionTagsHeader: "You've tagged",
    projectionTagsContent: 'as essential spend. Your top tags are',
    projectionTagsContent1: 'as essential spend. Your tag is',
    projectionTagsFooter: 'You can change these in Projections Settings',
    projectionCommitmentsHeader: 'You have no Commitments',
    projectionCurrentBalanceHeader: 'Your current balance is',
    projectionCurrentBalanceFooter:
      'This might be different to your available balance (you can check this in your account screen)',
    projectionBalanceHeader: 'The next coming into your account should be',
    projectionBalanceFooter:
      'This is projected in # days on the # of July See this in projection Settings',
    projectionSettingsCancel: 'Cancel',
    projectionSettingsOptOutOfProjections: 'Opt out of Projections',
    projectionSettingsEarningsAndCommitments: 'Earnings & Commitments',
    projectionSettingsEssentialSpending: 'Essential Spending',
    projectionSettingsAlertsAndNotifications: 'Alerts & Notifications',
    projectionSettingsEarningsAndCommitmentsHeader:
      'Check your Earnings & Commitments',
    projectionSettingsEarningsAndCommitmentsEarnings: 'Earnings',
    projectionSettingsEarningsAndCommitmentsStandingOrders: 'Standing Orders',
    projectionSettingsEarningsAndCommitmentsDirectDebits: 'Direct Debits',
    projectionSettingsEarningsAndCommitmentsLastKnown: 'Last Known',
    projectionSettingsEarningsAndCommitmentsFrequency: 'Frequency',
    projectionSettingsEarningsAndCommitmentsLastKnownAmount:
      'Last Known Amount',
    projectionSettingsDone: 'Done',
    projectionSettingsEssentialSpendingHeader:
      "Select the tags you regularly spend money on and they'll be included in your Projections",
    projectionSettingsEssentialSpendingOurTags: 'Our Tags',
    projectionSettingsEssentialSpendingYourTags: 'Your Tags',
    projectionSettingsAlertsAndNotificationsHeader:
      "Tell us how much you need left in your account; we'll alert you when you fall below that limit",
    projectionSettingsAlertsAndNotificationsContent: 'When I have a balance of',
    projectionSettingsAlertsAndNotificationsFooter:
      'Show me an on screen notification',
    projectionAlertAndNotificationsToggleText:
      'Send me an SMS when I enter a danger period',
    projectionLeaveProjectionsSetupPopupHeader: 'Leave Projections Setup',
    projectionLeaveProjectionsSetupPopupContent:
      'Are you sure you want to leave Projections setup? Your changes will not be saved.',
    projectionLeaveProjectionsSetupPopupCancelButton: 'Cancel',
    projectionLeaveProjectionsSetupPopupLeaveSetupButton: 'Leave setup',
    projectionOptOutOfProjectionsPopupHeader: 'Opt out of projections?',
    projectionOptOutOfProjectionsPopupContent:
      'Are you sure you want to opt out of Projections?',
    projectionOptOutOfProjectionsPopupCancelButton: 'Cancel',
    projectionOptOutOfProjectionsPopupOptOutButton: 'Opt out',
    projectedCrunchingHeader1: 'B is just crunching the numbers for you now.',
    projectedCrunchingHeader2:
      "It'll take a little time for B to calculate everything, so check back later.",
    projectionDoneButtonText: 'Done',
    projectionSpinWheelText: 'Spin the wheel to find out more',
    projectionSettingsCancelButton: 'Cancel',

    projectionSettingsOptOutOfProjection: 'Opt out of projections',
    projectionSettingsDoneButton: 'Done',
    projectionAlertsDropdownOption1: 'in my account',
    projectionAlertsDropdownOption2: 'in my overdraft',
    projectionPredictionTotalString: 'Total',
    projectionYouHaveString: 'You have ',
    projectedCommitmentBeforeYourNextEarnings:
      ' projected commitments before your next earnings',
    projectedCommitments: ' projected commitments',
    projectionPredictionEarningString: 'Earning',
    projectedPredictionEssentialSpendPreviosString:
      'Essential spend based on previous spending patterns',
    projectedBalanceInNext31Days: 'Your projected balance in the next 31 days',
    projectionPredictionYourProjectedBalanceBeforeNextEarning:
      'Your projected balance just before your next earning',
    projectedPredictionCurrentBalance: 'Current Balance',
    projectedPredictionYourThreshold: 'Your threshold',
    TutorialProjectionsslide1Text:
      "To start, B will take into account what you've tagged as earnings",
    TutorialProjectionsslide2Text:
      'Review your Commitments; these are Standing Orders and Direct Debits on your account',
    TutorialProjectionsslide3Text:
      'Select the tags which are essential to you, and B will incorporate the spending on these tags to make your projection more relevant',
    TutorialProjectionsslide4Text:
      'Look ahead and keep track of projected earnings and commitments, and receive alerts if you’re going to run low',
    TutorialProjectionsslide5Text:
      'B will give you a projected discretionary balance (good to go) or give you a heads up on when you may be running low',
    TutorialProjectionsslide6Text: 'Ready? Go',

    // Payment Thank you page
    trnasferOneOff: "Your money's on its way",
    paymentSuccesHeadingSO: "Your payment's been set up",
    paymentSuccesHeadingOneOff: "Your money's on its way",
    paymentSuccesSOFooterTomorrow: 'Your first payment will be made ',
    paymentSuccesSOFooterDate: 'Your first payment will be made on',
    paymentSuccesFDPFooterTomorrow: 'Your payment will be made ',
    paymentSuccesFDPFooterDate: 'Your payment will be made on ',
    scheduledFooter:
      'Please allow until tomorrow or the next working day for it to appear.',
    paymentSuccessSubHeaderFDP:
      'Your payment to <strong>{payeename}</strong> for <strong>{amount}</strong> has been scheduled.',
    paymentSuccessSubHeaderSO:
      'Your repeating payment to <strong>{payeename}</strong> for <strong>{amount}</strong> has been scheduled.',

    paymentSuccessSubHeaderOneOff:
      'Your payment for <strong>{amount}</strong> has been sent to <strong>{payeename}</strong>.',
    transferSuccessSubHeaderOneOff:
      'Your transfer to <strong>{payeename}</strong> has gone through for <strong>{amount}</strong>.',

    // Payment page
    nicknameHintText: 'Only you’ll see this.',
    accountNameHintText:
      'This is the name of the person who holds the account with this business',
    editpayeeHeader: 'Edit payment contact',
    fraudTitle: 'Protect yourself from fraud and scams',
    fraudIntro1:
      'Your bank and other trusted organisations will never ask you to move your money - but scammers will.',
    fraudIntro2:
      'So before you add this payee and send your money, take some time to stop and think:',

    fraudQuestions: [
      "Is someone you don't know pressurising you to make this payment?",
      'Have you been contacted by someone requesting you to move or transfer money to another account?',
    ],
    fraudRecovery:
      "If you make a payment to this payee and it turns out to be a scam, it's unlikely your money will be recovered. So if you're not sure, don't risk it.",
    fraudMoreInformation1: 'For more information, visit the',
    fraudMoreInformation2: 'on our website',
    fraudMoreInformationLinkUrl:
      '/personal/ways-of-banking/help-and-support/security',
    fraudMoreInformationLinkName: 'security section',
    fraudConfirm:
      "By ticking this box you confirm you're happy to add this payee and proceed with payments to them.",
    managePaymentLink: 'Manage your payments',
    paymentLink: 'Payment',
    crossIcon: 'cross',
    transferLink: 'Transfer',
    managePayeeLink: 'Manage who you pay',
    fromTitle: 'From',
    toTitle: 'To',
    payFrom: 'Paying from?',
    transFrom: 'Transfer from?',
    transTo: 'Transfer to?',
    howMuchTitle: 'How much?',
    currentTitle: 'current',
    available: 'available',
    newPayeeLink: 'Pay someone new',
    reference: 'Reference',
    accountHolderName: 'Account holder name',
    when: 'Date',
    repeatPayment: 'Repeat this payment',
    repeatPaymentText: 'Repeat this payment?',
    howOften: 'Repeat this payment',
    startDate: 'Start payment',
    stopitWhen: 'Stop payment',
    pickdate: 'On a set date',
    noOfTimes: 'After a set number of payments',
    ending: 'Ending',
    Weekly: 'Every week',
    twoWeekly: 'Every 2 weeks',
    threeWeekly: 'Every 3 weeks',
    fourWeekly: 'Every 4 weeks',
    monthly: 'Every month',
    twoMonthly: 'Every 2 months',
    threeMonthly: 'Every 3 months',
    sixMonthly: 'Every 6 months',
    anually: 'Every year',
    archivedPaymentsHead: 'Archived payments',
    archivedPaymentAll: 'All',
    payments: 'Payments',
    transfers: 'Transfers',
    directDebits: 'Direct debits',
    back: 'Back',
    archived: 'Archived',
    managePaymentTitle: 'Manage your payments',
    managePayee: 'Manage Your Payee',
    cancel: 'Cancel',
    accountLabel: 'Account',
    lastAmount: 'Last Amount',
    lastPayment: 'Last Payment',
    type: 'Type',
    status: 'Status',
    accountNumber: 'Account number',
    sortCode: 'Sort code',
    editSortCode: 'Sort Code',
    amount: 'Amount',
    nextDue: 'Due',
    paid: 'Paid',
    done: 'Done',
    delete: 'Delete',
    managePayments: 'Manage your payments',
    addPayeeContent: 'Pay someone new',
    editPayeeContent: 'Edit Payee',
    payeeName: 'Payee name',
    payeeSortCode: 'Sort code',
    payeeOrbill: 'Is it a bill or person',
    payeeAccountNumber: 'Account number',
    payeeReference: 'Reference',
    payeeNickName: 'Nickname',
    NAME: 'name',
    DELETE_PAYMENT_TYPE: 'DELETE_PAYMENT',
    chooseDate: 'Choose a date',
    schedule: 'schedule',
    end_condition: 'end_condition',
    nameOfThePerson: 'Name on account',
    nameOfThePersonHelpText:
      'We’ll ask their bank if the name matches what you’ve entered. You only need one name for a joint account.',
    nameOfTheCompany: 'Business name',
    nameOfTheCompanyHelpText:
      'We’ll ask their bank if the name matches what you’ve entered. Trading names might not match - an invoice should show the account name.',
    theirSortCode: 'Sort code',
    theirAccountNo: 'Account number',
    ReferencePayeeText: 'Helps you and the payee recognise the payment.',
    referenceErrorMsgMoveMoney: 'Please enter a reference for this payment.',
    referenceErrorMsgMoveMoneyTransfer:
      'Please enter a reference for this payment.',
    addPayeeCheckboxText1: 'Save in payee list',
    addPayeeCheckboxText2:
      'Save time and hassle when making and authorising payments to this payee.',
    addPayeeMoreInfoText:
      'Keep these details so you don’t have to enter them again and again. Saving this payee in your secure payee list could also help reduce the steps required to authorise future payments to them (payment approval limits will still apply).',
    addPayeeNickName: 'Nickname',
    addPayeeNickNameText1:
      'Allows you to use an alternative name for the payee. This will appear within online banking but',
    addPayeeNickNameText2: ' not on your statements.',
    bill: 'Bill',
    noOfTime: 'noOfTime',
    noOfTimeValidationMessage: 'Number of time should be of 2 digit or less',
    addPayee: 'Continue',
    addNewPayeeBack: 'Your payment contacts',
    addNewPayeeHeader: 'New payment contact',
    saveDetails: 'Save in payee list',
    payeeRequestPacket_Name: 'name',
    nameValidationMessage: 'Please use letters and spaces only.',
    payeeRequestPacket_account_id: 'account_id',
    payeeRequestPacket_sort_code: 'sort_code',
    sort_codeValidationMessage: 'Sort Code should be a 6 digit number',
    payeeRequestPacket_account_number: 'account_number',
    account_numberValidationMessage:
      'Account Number should be a 12 digit number',
    payeeRequestPacket_reference: 'reference',
    payeeRequestPacket_account_name: 'account_name',
    referenceValidationMessage: 'Invalid Reference',
    payeeRequestPacket_single_use: 'single_use',
    payeeRequestPacket_nick_name: 'display_name',
    display_name: 'display_name',
    nick_nameValidationMessage: 'Nick Name should not have special character',
    deletePayment: 'Delete payment contact',
    deleteBeneficiary: 'Delete Beneficiary',
    editPaymentText:
      'Your Payment has been edited, but the changes could take until tomorrow (or the next working day) to appear.',
    deletePaymentText:
      'Your Payment has been cancelled, but might still appear until tomorrow (or the next working day).',
    ok: 'OK',
    okButtonText: 'OK',
    beneficiary_id: 'beneficiary_id',
    DELETE_PAYEE_TYPE: 'DELETE_PAYEE',
    placeHolderContent: "Don't Forget",
    creditPopUpHeader: 'Please be aware...',
    creditPopUpBody:
      "If you use your credit card, there will be a cash advance fee to pay of 3% (min £3). The cash advance interest rate will also apply as per your credit card agreement. Are you sure that's OK? For further information please call the team on 0800 121 7365.",
    deletePayeePopUp: 'Are you sure you want to delete <br/> this beneficiary?',
    deletePayeePopUpmobile: 'Are you sure you want to delete this beneficiary?',
    AmountValidationMessage: 'Invalid Amount',
    mandateTypeDD: 'dd',
    mandateTypeSO: 'so',
    paymentContactTitle: 'Your payment contacts',
    nickName: 'NickName',
    viewDetails: 'View Details',
    thankYouText: 'Thank You',
    regularPayment: 'Your payment for ',
    regularTransfer: 'Your transfer to ',
    paymentThroughText: 'has gone through for',
    thankYouFooterText:
      'Please allow until tomorrow or the next working day for it to appear.',
    cancelTitle: 'Cancel',
    sureTitle: 'Are you sure?',
    active: 'Active',
    inactive: 'Inactive',
    single_use: 'single_use',
    account_Id: 'account_Id',
    edit: 'Edit',
    errorHeader: 'Error',
    eligibleErrMsg:
      'you cannot make an internal transfer because you have less than two elligible accounts',
    errorButton: 'OK',
    whenIcancel: 'When I cancel it',
    endDate: 'Stop payment',
    howManyTimes: 'Number of payments',
    makePayment: 'Make Payment',
    paymentBtn: 'Make payment',
    transferBtn: 'Make transfer',
    btnTextPaymentPopup: 'payment',
    btnTextTansferPopup: 'transfer',
    leaveMoveMoneyBodyText:
      "If you leave this page now, your transaction won't be completed.",
    leaveModalSecondaryButtonText: 'Leave page',
    leaveMoveMoneyPrimaryButtonText: 'Continue with {paymentType}',
    duplicatePayeeErrrmsg:
      'It looks like you’ve added these payment details before. Check the details you’ve entered and try again or choose this person or company from the list of who you pay.',
    IncorrectFormatPayeeErrorMsg:
      'Something is wrong with the format of the information in your entry. Please check your use of special characters in the Beneficiary Name, Address or Reference Fields.',
    makeTransfer: 'Make Transfer',
    loadingPaymentText: 'Loading payments data.....',
    isRepeat: 'Yes',
    confirmCancel: 'Confirm Cancel?',
    confirmCancelWeb: 'Confirm cancellation',
    accountName: 'Name',
    managePaymentFooter:
      "That's all of them. Any new payments you make will appear here.",
    archivedPaymentFooter:
      "That's all of them. Any archived payments will appear here.",
    editpopupStartText:
      "These changes only apply to this person or company for future payments.  If you are already paying them with a direct debit or standing order, you need to update that to the new details you've just saved.",
    editpopupEndText:
      "If you've got this person saved as a payee somewhere else outside B, for example in Clydesdale or Yorkshire Bank internet banking, you'll need to update that separately too.",
    cancelThisTransfer: 'Cancel this Transfer',
    cancelThisTransferweb: 'Cancel this transfer',
    cancelThisPayment: 'Cancel this Payment',
    NextButton: 'Next',
    Yes: 'Yes',
    No: 'No',
    editManagePayment: 'Edit payment',
    managePayment: 'Manage payment',
    managePaymentHeader: 'Manage payment',
    allDoneMessage: "All done. You're good to go.",
    toolTipMessageComplexSO:
      'This payment can’t be edited online. Need to make changes to it? Give the team at B a call or pop into your local branch.',
    unAllocatedHeader: 'Your Savings Pots are currently overallocated.',
    unAllocatedContent: 'Please take action to correct this immediately',
    availBalance: 'Available balance',
    amountValidationError:
      "You can't transfer more money out of a pot than is actually in it.",
    loadingPayeeText: 'Payee list loading...',
    someoneNewText: 'Someone new?',
    amountError: 'Cannot enter amount greater than available amount',
    oneOffPaymentText: 'Make a one-off transfer between your accounts',
    oneOffReapetPaymentText: 'Set up a regular transfer',
    thankOneOffRepeatText:
      'Please allow until tomorrow or the next working day for it to appear',
    setUpRegularTransfer: 'Set up a regular transfer',
    potMessage:
      "This payee can't set up standing orders or future-dated payments. If you choose it, you will only be able to make an single payment. Is this OK?",
    payingTo: 'Paying to?',
    whenHappen: 'When would you like this to happen?',
    whenGo: 'When do you want it to go through?',
    loadingAccounts: 'Loading Accounts...',
    referenceText: 'Enter Reference',
    potsLoading: 'Saving pot loading....',
    payeeRef: 'Ref',
    noPayeeMsgFirstLine: "Oops! You don't have anyone set up yet.",
    noPayeeMsgSecondLine:
      'Go back to the Payment screen and hit "Someone new?"',
    chooseValue: 'Choose a value',
    paymentText: 'Your payment for ',
    lastPaymentReference: 'Last Payment Reference',
    transferText: 'Your transfer to ',
    validationHead: 'By the Way',
    validationMsg:
      "It's not possible to process a payment after 4pm on the previous working day.",
    PayeeAccountNumber: 'Number',
    newPayee: 'Who you pay',
    subHeaderContent:
      "Choose <strong>'Person'</strong> to enter the details of the person or business you want to pay or <strong>'Company'</strong> to search for big organisations like credit card companies and local authorities - this can come in handy when you need to pay a bill or invoice.",
    addCompany:
      'If the company you want to pay is on our database, their payment details will be filled in for you. And if their details ever change in the future, they’ll be updated automatically.',
    payNew: 'Pay someone new',
    sweepTargetValidationMsg:
      'Oops. There has to be at least £100 between each amount.',
    referenceNumberText:
      'A note to help you remember why you moved this money. This will appear in your transactions list and statement.',
    repeatingPaymentText:
      "Choose <strong>'One-off'</strong> to move this money just once or <strong>'Repeating'</strong> if you want to set up a standing order.",
    paymentFrequencyText: 'Payment type',
    oneOffPayment: 'One-off payment',
    repeatingPayment: 'Repeating payment',
    datePickerText:
      'Use the date picker to select when you want this to happen. Alternatively, enter it in the format DD/MM/YYYY.',
    madePaymentText: 'has been made.',
    for: 'for',
    paymentSuccess: 'Success. Your payment will clear within 2 hours.',
    goToAccountsText: 'Go to your accounts',
    makeAnotherPaymentText: 'Make another payment or transfer',
    endDatePickerText:
      'Use the date picker to select when you want the repeating payment to stop. Alternatively, enter it in the format DD/MM/YYYY.',

    display_nameErrorMessage:
      'Enter a nickname for the person or company you want to pay then try again.',
    // SO DD Diffrence Modal changes
    DDSOModalTextHeader:
      'What’s the difference between a Direct Debit and a standing order?',
    DDDefinition:
      "A <strong>Direct Debit</strong>'s a repeating payment set up by the company you’re making payments to. You normally sign a mandate that gives them permission to take money from your account – like with a gym membership or phone bill. And you're protected under the Direct Debit guarantee scheme, so if money's ever debited in error, it's refunded straight away.",
    SODefinition:
      "A <strong>standing order</strong>'s a repeating payment you’ve set up on your own to pay other people or companies, or to transfer money between your own accounts.",
    DDSOInfo:
      "You can edit or cancel standing orders as and when you like. But if you want to change a Direct Debit, you’ll have to get in touch with the company you're paying to make the changes for you.",
    DDSOModalClose: 'OK',

    refErrorMsgManagePayments:
      'Enter a reference for this payment then try again.',
    amountErrorMessage: 'Enter the amount you want to pay then try again.',
    futureDateErrorMessage:
      'Choose the date you want the next payment to come out. This should be entered as DD/MM/YYYY.',
    nextDateErrorMessage:
      'Choose the date you want the next payment to come out. This should be entered as DD/MM/YYYY.',

    toolTipMessageDD:
      'If you want to make changes to a Direct Debit, you’ll have to get in touch with the company you’re paying to make them for you. You can cancel a Direct Debit on your own at any time but remember to let the company know so they don’t try to take money out your account.',
    cancelDDInfo:
      'You’re about to cancel the following Direct Debit. Before you do this, it’s recommended that you get in touch with the company you’re currently paying to let them know you’re cancelling it.',
    after4pmMessage:
      'One-off payments can be cancelled up to midnight on the business day before the payment is due to leave your account, for repeating standing orders it’s 4pm the business day before. If you cancel after this time money may still leave your account.',
    after4pmMessageDD:
      'You can cancel this up to 4pm on the business day before it’s due to be paid. If you cancel it after this time, the payment may still be taken.',
    cancelledFooter:
      "That's all of them. Any archived payments will appear here.",
    downloadMobileAppForSoftTokenText:
      '<p>To continue with this <payment>, you’ll have to authorise it using one of our online security tools – or go back and reduce the amount you’re trying to move.</p><p>The quickest way to authorise payments is to download the B app. Just search for <strong>‘B – manage your money’</strong> on the Apple App Store or Google Play Store, set up B on your mobile or tablet then come back and move your money. Simple.</p>',
    knowMoreText:
      'Need more info? Or want to find out about other ways of authorising payments? Check out the FAQs in the help section or get in touch with the team at B.',
    reduceAmountButton: 'Ok, got it',
    goGetBText: 'Close this and go get B',
    softTokenErrorHeading: 'Give this <payment> the OK',
    // Feature 5 Savings Pot
    internalServerError: 'Internal Server Error',
    savingDone: 'Done',
    SavingsAcc: 'Savings account',
    SavingLinkPot: 'Want to create a new Savings Pot?',
    SavingLinkSetupPotMobile: 'Set up a new Savings Pot',
    SavingLinkAddPotMobile: 'Add new savings pot',
    savingpotNoPotMobile:
      "Savings Pots are a way of saving for the \n things you've always wanted. You can \n tailor your pots using our calculator, to \n make them work within your budget. Then \n keep up to date with your progress and \n make edits as things change, as they \n always do!",
    savingpotNoSavingAccount1:
      "Savings Pots are a way of saving for the things you've always \n wanted. You can tailor your pots using our calculator, \n to make them work within your budget. Then keep up \n to date with your progress and make edits as things \n change, as they always do!",
    savingpotNoSavingAccount2:
      'To use Savings Pots, you need to open a B Savings account.',
    savingPotDeleteTitle: 'Are you sure?',
    savingPotDetailDeletMessage1:
      "Remember to cancel any regular transfers you've set up.",
    savingPotDetailDeletMessage2:
      "Don't worry all your money will stay in your savings account.",
    savingPotRejigDeletMessage1:
      "Are you sure you want to delete this Savings Pot? You won't be able to cancel the deletion afterwards.",
    savingPotRejigDeletMessage2:
      'Deleting this pot will not cancel any associated standing orders; please do this manually.',
    savingpotmessage:
      "Savings Pots are a way of saving for the things you've always\nwanted. You can tailor your pots using our calculator,\nto make them work within your budget. Then keep up\nto date with your progress and make edits as things\nchange, as they always do!\n\nTo use Savings Pots, you need to open a B Savings account.",
    savingpotNopotMessage:
      'To use Savings Pots, you need to open a B Savings account.',
    savingpotcreationcolumn1: 'I’d like to save',
    savingpotcreationcolumn2: 'Kick it off with',
    savingpotcreationcolumn6: 'My current balance is',
    savingpotcreationcolumn3: 'Have it by',
    savingpotcreationcolumn4: 'And I can put this much away a month',
    savingpotreducemessage1:
      'You need a rejig. You have taken some money out of your savings account so you need to reduce your savings pots by',
    savingpotreducemessage2:
      'Fancy a rejig? You have more money in your savings account than in your pots so could top them up by',
    savingpotcurrentbank: 'Current balance of account ',
    savingpottotalallocated: 'Total allocated to pots',
    savingpotcurrentbankmobile: 'Current balance',
    savingpotTitle: 'Savings Pots',
    savingpotAllocatedTitle: 'Allocated',
    savingpotTargetDate: 'Target date',
    savingpotAimingBal: " You're aiming for",
    savingpotByBal: 'by',
    savingpotByputtingAway: 'by putting away',
    savingpotAmonth: 'a month',
    savingpotMainPageTitle1: 'You have',
    savingpotMainPageTitle2: 'that could go in a Savings Pot',
    savingPotRejigTitle: 'Uh oh, fancy a rejig?',
    savingpotRejigMessage1: "You've earmarked",
    savingpotRejigMessage2:
      'more for your Savings Pot(s) than you have in this account. To make sure things add up, please do one of the following: ',
    savingpotAccountTitle: 'Savings accounts',
    savingPotCreatePotButton: 'Create pot',
    savingsPotCancelButton: 'Cancel',

    savingPotSaveButton: 'Save',
    savingPotConfirmChangeButton: 'Confirm changes',
    savingsPotNameLabel: 'Enter a name for your Savings Pot',
    savingsPotYesButton: 'Yes',
    potMessageHead1: 'Goal!',
    potMessage1Part: 'Congratulations … you’ve hit your target of',
    potMessageHead2: 'Hmmm',
    potMessage2Part1: ' Put away',
    potMessage2Part2: ' every month and you won’t hit',
    potMessage2Part3: ' unless you happen to have a time machine handy.',
    potMessage2Part4: 'Do you want to crank things up a bit?',
    potMessage2Part5: 'every month and you won’t hit',
    potMessageHead3: "It's going great",
    potMessage3Part1: 'To stay on track put away',
    potMessage3Part2: 'this month and every month ‘til your target date of',
    potMessage3Part3: 'and you’ll save',
    potMessage3Part4: 'Congrats.',
    potMessage3Part5: 'this month and every month ‘til your target date of',
    potMessageHead4: 'Happy to wait?',
    potMessage4Part2: 'this month, and you won’t hit your target of',
    potMessage4Part3: 'until',
    potMessage4Part4:
      'If that’s OK, great. If not, you might want to bring it forward to',
    potMessage4Part5: 'by upping your monthly amount to',
    potMessageHead5: "You've got wiggle room",
    potMessage5Part2: 'a month and you’ll have',
    potMessage5Part3: 'by your target date of',
    potMessage5Part4: 'Though you can reduce your monthly amount to',
    potMessage5Part5: 'and you will still hit your target by',
    potMessage5Part6: 'and you’ll still hit your target date of',
    potMessageHead6: 'Keep going',
    potMessage6Part1: "It's all going according to plan.",
    potMessageHead7: 'Think of a goal - large or small',
    potMessage7Part1:
      'How much would you need to put into a Savings Pot to make it happen?',
    potMessage8Part2: 'a month and you are unlikely to hit',
    potMessage8Part3: 'You might want to crank things up a bit.',
    potMessageHead8: 'That’s spot on',
    potMessage7Part2: 'a month, and you’ll save',
    potMessage7Part3: 'Happy days.',
    potMessage7Part4: 'It might take a while',
    potMessage7Part5: 'a month, and you’ll have',
    potMessage7Part6: "You'll smash it",
    potMessage7Part7: "and you'll have",
    potMessage7Part8: 'a month and you’ll have',
    potMessage8Part1: 'if you want to take things a bit easier and do it by',
    potMessage1: 'You will meet your goal instantly.',
    potMessage9Part1: ' Never mind',
    potMessage9Part2: " You've not hit your goal of ",
    potMessage9Part3: ' by ',
    potMessage9Part4: ' Still, why not grant yourself an extension?',
    potMessage9Part5: 'As they say, better late than never',
    potDetailMessage5Part2: 'your usual ',
    potDetailMessage5Part3: 'this month and you’ll have',
    potDetailMessage5Part4: 'by',
    potDetailMessage5Part5: 'Though you could cut your payments to',
    potDetailMessage5Part6:
      'a month and still hit your target by the same date.',
    potDetailMessage4Part2: ' this month, and you won’t hit your target of',
    potDetailMessage4Part3: ' until ',
    savingPotDeletePotButton: 'Delete Savings Pot',
    savingPotDeletePotButtonMobile: 'Delete this pot',
    savingsPotConfirmationMessage: 'Great. Your Savings Pot has been created',
    savingsPotConfirmationTransfer:
      'Want to make a one-off transfer to kick start it now?',
    savingsPotConfirmationTransferMobile:
      'Make a one-off transfer to start it now',
    savingsPotConfirmationTransferRegular: 'Or set up a regular transfer?',
    savingPotMoveMoneyButtonMobile: 'Move money',
    savingPotMoveMoneyButton: 'Move Money',
    savingPotEditPotButton: 'Edit Savings Pot',
    savingPotEditPotButtonMobile: 'Edit this pot',
    savingPotReduceRejigButton: 'Reduce or delete Savings Pots',
    savingPotMoveMoneyButton2: 'Move money into my savings account',
    savingPotCurrencyType: 'GBP',
    savingPotCreateHeading: 'Create Savings Pot in',
    savingPotEditHeading: 'Edit my Savings Pot in',
    savingPotCreateHeadingMobile: 'Create Savings Pot',
    savingPotEditHeadingMobile: 'Edit my Savings Pot',
    savingPotDateDefaultText: 'Choose...',
    SavingPotUnallocatedText: 'unallocated',
    savingPotwayToGoHead: 'Way to go',
    savingPotReduce: 'Reduce Savings Pots',
    savingPotModalText1:
      "You've already used that name for a different Savings Pot. Please choose a different name.",
    savingPotModalText2:
      "You've not entered the pot name. Please enter the Pot Name.",
    savingpotscurrentlyunavailable1: 'Savings Pots are currently unavailable,',
    savingpotscurrentlyunavailable2: ' please try again later.',

    // Feature 5 Spendings
    spendingAccountButtonLabel: 'Accounts',
    spendingCancelButtonText: 'Cancel',
    spendingOkButtonText: 'Ok',
    spendingNextButtonText: 'Next',
    spendingSaveButtonText: 'Save',
    spendingTryButtonText: 'Try again',
    spendingDoneButtonText: 'Done',

    spendingHeaderTitle: "What you've spent this month vs",
    spendingHeaderTitle1: 'vs Budget',
    spendingHeaderTitle2: 'Spent vs',
    spendingHeaderButtonLabel: 'Your budget',
    spendingHeaderButtonLabel2: 'Create budget',
    spendingHeaderButtonLabel3: 'Edit budget',
    spendingHeaderButtonLabel4: 'Create Budget',
    spendingHeaderButtonLabel5: 'Edit Budget',
    spendingHeaderThisMonthText: 'This month',
    spendingHeaderNoBudgetWatning:
      'Setting up a budget helps you plan your spending each month.',
    spendingHeaderNoBudgetWatning1:
      'Setting a budget helps you plan your spending each month',
    spendingHeaderNoBudgetTitle: "Here's where things get interesting.",
    spendingHeaderNoBudgetMessage:
      "There's not much to see here yet, but as you start spending with B you'll see how you're doing against previous months.",
    spendingHeaderBudgetText: 'Budgeted',
    spendingProgressText1: 'Budget',
    spendingProgressText2: 'Pots',
    spendingProgressText3: 'Income',
    spendingDaysLeftText: 'days left in this month',
    spendingTableHeaderText1: 'Tag',
    spendingTableHeaderText2: 'Spent this month',
    spendingTableHeaderText3: 'Amount Budgeted',
    spendingTableHeaderText4: 'Status',
    spendingTableHeaderText5: 'Difference',
    spendingTableHeaderText6: 'Spent in',
    spendingTableHeaderText7: 'Last month',
    spendingTableHeaderText8: 'Budget',
    spendingTableHeaderText9: 'Date',
    spendingTableHeaderText10: 'Description',
    spendingTableHeaderText11: 'Type',
    spendingTableHeaderText12: 'Tag',
    spendingTableHeaderText13: 'Amount',
    spendingTableHeaderText14: 'Account',
    spendingTableLoading: 'Loading Data...',
    spendingTableLoading1: 'No transactions found',
    spendingTableMessage1: 'Great news, you have no untagged transactions.',
    spendingTableMessage2: 'How about tagging these transactions?',
    spendingTableMessage3: 'over budget!',
    spendingTableMessage4: 'left to spend',
    spendingTableMessage5: 'No budget set yet',
    spendingTableMessage6: 'more than last month',
    spendingTableMessage7: 'less than last month',
    spendingTableMessage8: 'no difference!',
    spendingTableMessage9: 'Nothing left to spend',
    spendingTableMessage10: 'No budget',
    spendingEarningMessage:
      "Here are your anticipated monthly earnings. Please change the amount if it's not quite right.",
    spendingEarningMessage1: 'Please enter your anticipated earnings',
    spendingCreateHeaderLeftLabel: 'Pots & budget',
    spendingCreateHeaderRightLabel: 'Earnings',
    spendingCreateMessageTitleText1: 'Nice',
    spendingCreateMessageTitleText2: 'Uh oh, fancy a rejig?',
    spendingCreateMessageCopyText1: 'Your budget this month is',
    spendingCreateMessageCopyText2: " and you're hoping to save",
    spendingCreateMessageCopyText3: 'This means you have',
    spendingCreateMessageCopyText4: 'left over.',
    spendingCreateMessageCopyText5: "This means you're short by",
    spendingCreateMessageCopyText6: 'You have',
    spendingCreateMessageCopyText7: "You're short by",
    spendingCreateMessageCopyText8: 'Your budget is',
    spendingCreateMessageCopyText9: 'left over',
    spendingPotTooltipMessage:
      'You can edit the amount allocated to your pots in the pots screen later',
    spendingJointTooltipMessage:
      'These are joint tags that your joint account holder has created. You can still allocate budget to them',
    spendingTransitionHeaderText1: 'Your',
    spendingTransitionHeaderText2: 'transactions',
    spendingTransitionInProgressHeaderText: 'In progress',
    spendingTransitionInProgressMessage: 'This is still going through.',
    spendingNoSpendTitle: 'Spending',
    spendingNoSpend: 'We were unable to load your spending at this time.',
    spendingCloserLook: 'Take a closer look',
    csrText: 'Current savings interest rate <strong>amount% AER</strong>',
    savingspotTileText: 'Set up pots, save up lots',
    savingspotTileBtnLabel: 'Go to Savings Pots >',
    fsCloserLook: 'Take a closer look...',
    // Dispute payments
    pendingPaymentTitle: 'The payment is pending',
    pendingPaymentText1:
      "If it's been pending for more than 5 days, contact the seller to see what's going on.",
    helpWithPaymentTitle: 'Help with this payment',
    helpWithPaymentCancelTitle: 'I want to cancel the payment or get more info',
    helpWithPaymentCancelText:
      'Our digital host, Redi, can help you if you have questions about this payment.',
    helpWithPaymentFraudTitle: "I didn't make this payment",
    helpWithPaymentFraudText:
      'If you think someone else made this payment, it could be fraud. We can help to make sure your account is secure.',
    helpWithPaymentDisputeTitle: "I made this payment but there's a problem",
    helpWithPaymentDisputeText:
      "For example, if you haven't received what you've paid for or you've been charged the wrong amount.",
    helpWithPaymentDisputeModalTitle: 'Dispute this payment',
    helpWithPaymentDisputeBodyBold:
      "If there's a problem with something you've paid for, and you can't work things out with the seller, you can dispute the payment.",
    helpWithPaymentDisputeTicklistTitle1:
      'We can try to get your money back if:',
    helpWithPaymentDisputeTicklist1: [
      "You haven't received what you paid for",
      "You've been charged the wrong amount",
      'You receieved something that was damaged or not as described',
      "You haven't recieved a refund when you were supposed to",
    ],
    helpWithPaymentDisputeTicklistTitle2:
      'We can try to get your money back if:',
    helpWithPaymentDisputeTicklist2: [
      "It's still a pending payment",
      "You haven't given the seller a chance to make things right",
      "The expected delivery date hasn't passed yet",
      "The payment wasn't made on your debit card",
    ],
    callPaymentTitle: 'Give us a call',
    callPaymentText1:
      "If you've been overcharged, you can claim anytime up to 90 days after the goods or services should have been delivered.",
    callPaymentText2:
      "We'll need to prove how you were overcharged so have some evidence handy.",
    callPaymentText3: 'Call us on ',
    callPaymentText4: '0800 121 4254',
    callPaymentText5:
      ", We're available Monday to Friday, 8am to 7pm, and Saturday, 9am to 5pm. Calls are free from UK landlines and personal mobiles.",
    thirtyDayPaymentTitle: "You can't dispute this payment yet",
    thirtyDayPaymentText1:
      'It needs to be at least 30 days since the payment was made.',
    disputePaymentTitle: 'Getting started',
    disputePaymentText1:
      'To help you try to get your money back, we need to ask you some questions about your dispute. It should only take a few minutes.',
    disputePaymentSubTitle: "What's gone wrong?",
    disputePaymentOption1:
      "You haven't received your goods or services (including flights or holidays)",
    disputePaymentOption2:
      'You have been charged more than once or charged the wrong amount',
    disputePaymentOption3:
      'You received an item that was damaged, fake or not as described',
    disputePaymentOption4:
      "You haven't receieved a refund, credit or replacement",
    contactSellerTitle: 'Have you contacted the seller?',
    contactSellerText1:
      "Before you dispute a payment, you'll need to try and get things resolved with the seller.",
    contactSellerText2:
      "If you've contacted them, we'll ask for more information on what happened.",
    // Homepage
    warningIconTextProjection: "Uh oh, looks like you're running low.",
    warningIconTextRejigCase:
      'Uh oh, you’ve earmarked more for your Savings Pot(s) than you have in this account.',
    // Products
    productPageTitle: 'ProductsPage',
    products: 'Products',
    productsContent:
      'Because B is powered by the people at Clydesdale Bank and Yorkshire Bank, you can get your hands on lots of products to help you manage your money.<br></br>Before you check them out, here are some details to keep in mind. Fees and charges may apply to some of these products and security may be needed too. All credit facilities are subject to status and age restrictions may also apply.',
    linkText:
      'These links will open in a new window or tab. If you like what you see and don’t come back in 5 minutes, you’ll be automatically logged out of B on Web.',
    productHeadErrorMessage:
      'We were unable to load your products at this time.',
    productBodyErrorMessage: '',

    logOutWarningText:
      'If you like what you see and don’t come back in 5 minutes, you’ll be automatically logged out of B on Web.',
    productsModelContent:
      'This link will open in a new window or tab and will take you out of B on Web. If you like what you see and don’t come back in 5 minutes, you’ll be automatically logged out.',
    productsModelNonBProductContent:
      'This product is powered by XXXXX Bank.<br/><br/>This link will take you out of B on Web to the XXXXX Bank website and will open in a new window or tab.<br/><br/>If you like what you see and don’t come back in 5 minutes, you’ll be automatically logged out.',
    modalHeading: 'Opening in new window',
    modalFooter: '',
    productsFooterText:
      "Your home may be repossessed if you don't keep up repayments on your mortgage",
    cancelButtonText: 'Cancel',
    continueButtonText: 'Continue',
    nonBContinueButtonText: 'Continue to XXXXX ',
    activateHardTokenHeading: 'Activate security token',
    activateHardTokenDescription:
      'Activate your token now to get even more protection when you bank online.',
    activateHardTokenLink: 'Activate it',

    // virgin money loans merged with CB YB B
    loansModalHeading: 'We’ve joined forces with Virgin Money',
    loansModelContent1:
      'Clydesdale Bank, Yorkshire Bank and B have teamed up with Virgin Money to become one bigger, better and brighter bank.',
    loansModelContent2:
      'So if you continue with a loan application, you’ll be applying for a Virgin Money loan.',
    loansModelContent3:
      "With a Virgin Money loan, you’ll get the best of both worlds. Clydesdale and Yorkshire Bank's experience and Virgin's forward-thinking innovation. It’s the perfect bank balance.",
    loansModelContent4:
      'That’s enough about us. Let’s get going and help make your plans a reality.',
    loansContinueButtonText: 'OK, got it',

    // Error page text
    errorText1: 'Something’s gone wrong',
    errorText2: 'Hmm. Looks like there’s been a technical problem.',
    errorText3:
      'Log out then log back in to try again. Still not working? Get in touch with the team at B.',

    // BOW Error Messages.
    AmountErrorMsg: 'Amount Field is required!',
    AmountErrorMsgLimit: 'value must be less than £500.00',
    CompanyErrorMsg: 'Compnay Field is required!',
    NameErrorMsg: 'Name is required!',
    NickNameErrorMsg: 'Nick Name is required!',
    SortCodeErrorMsg: 'Sort Code is required!',
    SortCodeErrorMsgLimit: 'Sort Code is required!',
    AccNumErrorMsg: 'Account number is required!',
    radioErrorMsg: 'Radio selection required!',
    checkboxErrorMsg: 'Checkbox selection required!',

    fsTileErrorHeading: "We can't show you this story right now.",
    fsTileErrorButtonLabel: "We'll keep trying though…",

    // Chat tile Display Messages
    chatHeading: 'Want to chat?',
    chatDescription:
      'The team at B will keep chat transcripts for training, legal and compliance reasons.',
    genericChatSubheading: 'Launch live chat to talk to the team at B.',
    // Generic Chat Tile Display Messages
    genericChatHeading: 'Need help? Chat to us',
    genericChatDescription:
      'The Virgin Money team will keep chat transcripts for training, legal and compliance reasons.',
    genericChatButtonText: 'Launch live chat',

    helmetTitlePaper: 'Order a paper statement',
    titlePaper: 'Order a paper statement',
    mainDescriptionPaper:
      'Did you know that online statements are now available on B on Web and the B app?',
    subDescriptionPaper:
      'You can view your statements whenever you need them. And you can download and print them straight from your mobile, tablet or computer. It’s simple, secure and convenient.',
    linkNamePaper: 'View, download or print an online statement',
    orderButtonNamePaper: 'Order now',
    modelTitlePaper: "Your statement's on its way",
    subContent1: 'Need a paper copy of your statement? ',
    callUsText: 'Give the team at B a call ',
    subContent2:
      ' and they’ll send it to your registered address within 7–10 business days. We’ll send your statement to your registered address within 7–10 business days.',

    // order cheque book
    helmetTitleCheque: 'Order a new cheque book',
    titleCheque: 'Order a new cheque book',
    mainDescriptionCheque:
      'Already had a cheque book for this account? Go ahead and order a new one now.',
    mainDescription2Cheque:
      'The team at B will send it to your registered address within 7–10 business days.',
    subDescriptionCheque:
      'Give the team at B a call and they’ll get one ordered for you.',
    subTitleCheque: 'Never had a cheque book before?',

    orderButtonNameCheque: 'Order now',
    modelTitleCheque: 'Your cheque book’s on its way',
    modelBodyContentCheque:
      'Happy days. Your new cheque book will be popped through your letterbox within 7–10 business days.',
    modelOkButtonCheque: 'OK',
    // order payin
    helmetTitlePayin: 'Order a new pay-in book',
    titlePayin: 'Order a new pay-in book',
    mainDescriptionPayin:
      'Already had a pay-in book for this account? Go ahead and order a new one now.',
    mainDescription2Payin:
      'The team at B will send it to your registered address within 7–10 business days.',
    subDescriptionPayin:
      'Give the team at B a call and they’ll get one ordered for you.',
    subTitlePayin: 'Never had a pay-in book before?',

    orderButtonNamePayin: 'Order now',
    modelTitlePayin: 'Your pay-in book’s on its way',
    modelBodyContentPayin:
      'Happy days. Your new pay-in book will be popped through your letterbox within 7–10 business days.',
    modelOkButtonPayin: 'OK',
    // CMA Alerts
    alertAccountPageHeading: 'Manage your alerts',
    alertAccountPageDescription:
      'B’s handy alerts help you stay in control and keep track of your money. Choose what account you want to manage the alerts for.',
    alertAccountPageFooterDescription:
      'Got an account that’s not here? Alerts are only available for the accounts shown above right now.',

    alertListHeading: 'Manage your alerts',
    alertListDescription:
      'Got another account? Alerts are only available for this one right now.',
    alertListCMAHeading: 'Take action alerts',
    alertListCMASubHeading:
      'Send me a text when my account balance is too low to cover a payment or if a payment takes me into unarranged overdraft.',
    alertListCMAMoreButtonName: 'Find out more',
    alertListCMASubDescription:
      'These alerts will let you know when you’ll have to pay money in for payments to go through or to avoid an unarranged overdraft and possible charges. Want to turn them off? That’s totally up to you – but they may help you avoid fees and charges.',
    alertListCustomAlertHeading: 'Custom alerts',
    alertListWBHeading: 'Weekly balance update',
    alertListWBcontentDesc: 'Send me a text every',
    alertListWBContentSubDec: 'to let me know how much I’ve got in my account.',
    alertListHighAlertHeading: 'High balance alert',
    alertListHighAlertContentDesc: 'Send me a text when I’ve got more than',
    alertListHighAlertContentSubDesc: ' in my account.',
    alertListLowAlertHeading: 'Low balance alert ',
    alertListLowAlertContentDesc: 'Send me a text when I’ve got less than',
    alertListLowAlertContentSubDesc: ' in my account.',
    alertListSweepHeading: 'Sweep',
    alertListSweepDesc: 'When I’ve got less than',
    alertListSweepDesc2: 'in this account, move money into it from my',
    alertListSweepDesc3: 'account to take me back up to',
    alertListProjectionHeading: 'Projected low balance alert',
    alertListProjectionSubDesc:
      'Send me a text when my projected balance is less than',

    alertWBHeading: 'Weekly balance update',
    alertWBSubHeading:
      'Send me a text to let me know how much I’ve got in my account every',

    alertHighBalanceHeading: 'High balance alert',
    alertHighBalanceSubDesc: 'Send me a text when I’ve got more than',

    alertLowBalanceHeading: 'Low balance alert',
    alertLowBalanceSubDesc: 'Send me a text when I’ve got less than',

    alertSweepHeading: 'Sweep',
    alertSweepSubDesc1: 'When I’ve got less than',
    alertSweepSubDesc2: 'Move money from',
    alertSweepSubDesc3: 'To take me back up to',
    alertSweepAmountDiffMessage:
      'There has to be at least £100 between each amount. So if you’ve got less than £50, you’ll have to go back up to £150 or more.',

    alertProjectionHeading: 'Projected low balance alert',
    alertProjectionDesc:
      'Send me a text when my projected balance is less than',

    cancelButtonName: 'Cancel',
    confirmButtonName: 'Confirm',

    sweepModalHeading: 'Switch off sweep?',

    sweepModalBody1:
      'Personalised any amounts? If you switch this back on, you’ll have to set them up again from scratch.',
    sweepModalBody:
      "This won't just switch off the alert you get – it'll switch off the sweep that moves money into your account too.",

    sweepModalSwitchOffCancel: "Don't switch off",
    sweepModalSwitchOffOkay: 'OK, switch off',

    // Account Reorder
    accountReorderHeader: 'Change account order',
    accountReorderHeader1:
      "Here's the order your accounts will be shown in when you're on B on Web.",
    accountReorderFavouritesHeader:
      'This is the order your favourite accounts will appear within Business Internet Banking.',
    accountReorderAddFavourites:
      'You can only change the order of accounts you’ve marked as favourites.',
    arrowButtonsUseTip:
      'Change the order of your accounts using the arrow buttons below.',

    eGainChatModelHeader: 'Launching in new window',
    eGainChatModelText:
      'The live chat tool will open up in a new window. If you’re busy chatting to the team at B and don’t use B on Web within the next 5 minutes, you’ll be automatically logged out.',
    eGainChatModelButtonText: 'OK, chat now',
    clearedBalance: 'Cleared balance',
    isaTaxYearDisplayText: 'Subscriptions made so far this tax year',
    isaTotalDepositDisplayText: 'Maximum you can still put in this tax year',
    isaTaxYearDepositExplanationText:
      'This amount is the total of all the money you’ve put in minus any withdrawals from this cash ISA in this tax year. Want to find out more about ISA limits and rules? Check out the ',
    isaTotalDepositExplanationText:
      'This amount is only based on the money you’ve put into or taken out of this cash ISA. If you’ve put money in other types of ISA this tax year, you might not have this much left. Want to find out more about ISA limits and rules? Check out the ',
    // Payment SME Contents
    paymentSMEHeader: 'Pay or transfer money',
    paymentSMESubHeader:
      'Pay a bill, person or organisation or transfer money between your accounts. You can save time by setting up repeating transactions or making multiple payments and transfers at the one time.',
    paymentSMEUnauthorisedSubHeader:
      'You don’t have permission to make payments and transfers. Please contact your corporate administrator for more information',
    multiplePaymentQuickLink: 'Make multiple payments',
    smeReviewWarningHeader: "Your payment hasn't been made yet",
    smeReviewWarningBody:
      "If you leave this page now, your transaction won't be completed.",
    leaveThePage: 'Leave page',
    continueWithPayment: 'Continue with payment',

    // Fate of payment content
    quickLinkPaymentStatus: 'Payments status and history',
    paymentHistoryToolTipMessage:
      'The payments list only shows payments you’ve made within mobile and internet banking. It doesn’t include transactions you’ve made with your debit card, for example, or Direct Debits taken by companies. You can view these in your transaction list on the account page.',
    paymentHistoryListHeader: 'Payment List',
    paymentHistoryNoDataMsg: 'No Payments Found. Try changing your date range.',
    paymentHistoryMobileNoDataMsg:
      'No Payments Found. You can only see your last three months payments using your mobile device.',
    paymentHistoryFilterFromErrorMsg:
      'Something’s not right there. Make sure the date you’ve entered is less than 13 Months ago and before the date you want to view your payments up to',
    smePaymentHistoryFilterFromErrorMsg:
      'Something’s not right there. Make sure the date you’ve entered is less than 18 Months ago and before the date you want to view your payments up to',
    paymentHistoryFilterToFieldErrorMsg:
      'Something’s not right there. Make sure the date you’ve entered isn’t in the future or before the date you want to view your payments from',
    paymentHistoryFooterMsg:
      'That’s all we can find. Try changing your date range.',
    paymentHistoryMobileFooterMsg:
      'That’s all we can find. You can only see your last three months payments using your mobile device.',
    showMore: 'Show More',
    accountPickerLabel: 'Accounts',
    searchPaymentHistoryEmptyMsg:
      'No payments found. Try changing your search criteria.',
    paymentHistoryNoTransactionMsg:
      'No payments found. Try changing your date range or payment status',

    // Secure Message
    communicationsHub: 'Communications Hub',
    secureMessages: 'Secure messages',
    youGot: "You've got ",
    newSecureMessages: ' new secure messages',
    oneSecureMessage: ' new secure message',
    messageTitle: 'Message',
    messageContent:
      'Share your details with the team at B and get all the help you need. It’s simple, safe and secure.',
    newSecureMessage: 'Secure messaging',
    leaveMessageUsTitle: "Oops, your message hasn't sent yet",
    leaveMessageUsBody:
      "Sure you want to leave this page? If you do, your message won't be sent or saved as a draft.",
    leaveMessageUsPrimaryButtonText: 'Continue with message',

    // Secure Message Lets chat Modal
    letsChatModalTitle: "Looking for help? Let's chat",
    youCanSendMessage:
      'You can now send and receive secure messages in a flash with our new instant message service.',
    manyCustomersAreUsingMsg:
      'Many customers are already getting help and advice right away, just by selecting Let’s chat.',
    withLetsChatMsg: 'With Let’s chat, you can:',
    withLetsChatDescList: {
      getInTouchMsg: 'Get in touch day or night',
      getAnInstantReplyMsg: 'Get an instant reply',
      manageYourAccountMsg:
        'Manage your account and chat with us at the same time',
    },
    easyToUseMsg:
      "It’s easy to use, and you’ll still be able to access the current service as normal. Just remember, you won't see your old secure messages in Let’s chat.",
    continueToSecMsgBtnTxt: 'Continue with secure messaging',
    letsChatBtnTxt: 'Let’s chat',
    dontShowAgainMsg: 'Don’t show this again',

    ibanAndBicInfo:
      'If someone’s sending you money from abroad, you’ll have to give them your IBAN (International Bank Account Number) and BIC (Bank Identifier Code) to receive your payment.',
    authorisationAlertSingularMsg: 'You’ve got a ',
    authorisationAlertPluralMsg: 'You’ve got ',
    authorisationAlertSingularAnchorBody: 'payment to authorise.',
    authorisationAlertPluralAnchorBody: 'payments to authorise.',
    // Beneficiary copy
    benSyncLandingHeader: 'Bring your payees over to B',
    benSyncLandingSubHeader1:
      'It’s time to move your payees from our old internet banking service over to B. Simply pick the ones you want and they’ll be available on B on Web and the B app. Easy peasy.',
    benSyncLandingSubHeader2:
      'FYI: Any payees you transfer over will be visible to other account holders on your joint account.',
    benSyncPickPayee: 'Pick your payees',
    benSyncPayeeFound: 'payee found',
    benSyncPayeesFound: 'payees found',
    benSyncColumnHeaderName: 'Payee name',
    benSyncColumnHeaderNickname: 'Nickname',
    benSyncColumnHeaderAccNo: 'Sort code and account number',
    benSyncColumnHeaderReference: 'Reference',
    benSyncFooterMessage:
      'That’s them all. Only payees that you’ve paid in the last 12 months can be moved over to B.',
    benSyncButton: 'Bring payees over to B',
    benSyncNoPayeeSelected:
      'Validation message if the customer doesn’t select any payees: Oops, you’ll have to pick at least one payee to continue.',
    benSyncCancelPopupHeader: 'Sure you want to cancel?',
    benSyncCancelPopupBody:
      'If you cancel now, none of your payees will be moved over to B.',
    benSyncPopupYesButton: 'Yes, cancel',
    benSyncPopupNoButton: "No, don't cancel",
    benSyncSuccesHeader: 'All done',
    benSyncSuccesBody: 'Your payees have been successfully moved over to B.',
    benSyncNoPayeeHeader: 'Nothing to see here',
    benSyncNoPayeeBody:
      'Hmm, looks like you don’t have any payees to bring across. Only payees that you’ve paid in the last 12 months can be moved over to B.',
    benSyncCalloutBody:
      'You can now move your payees from our old internet banking service over to B. Simply pick the ones you want and they’ll be available on B on Web and the B app. Easy peasy.',
    benSyncCalloutBody1:
      'FYI: Any payees you transfer over will be visible to other account holders on your joint account.',
    benSyncCalloutHeader: 'Bring your payees over to B',
    benSyncCalloutButton: 'OK, get started',
    benSyncChooseAccountHeader: 'Choose what account to link these payees to',
    benSyncChooseAccountBody:
      "You'll still be able to move money to these payees from your other accounts.",
    benSyncChooseAccountInlineError:
      'Oops, you’ll have to choose an account to continue.',
    selectAll: 'Select All',

    // SME Payment History
    smePaymentHistoryTitle: 'Payment status and history',
    smePaymentHistoryIntroduction:
      'Keep track of the payments and transfers you’ve made from internet banking or your mobile banking app.',

    // Paperless Preferences
    paperlessReasonsTitle: 'Going digital with letters and statements',
    paperlessReason1:
      'Easy to find, view and download - no more searching through your cupboards or drawers to find your documents',
    paperlessReason2:
      'Reduces your filing, shredding or recycling chores - reducing paper waste',
    paperlessReason3:
      'Securely stored and available online 24/7 within internet banking and the mobile app - no need to wait for the post',
    paperlessReason4:
      'Change your preferences at any time or get in touch if you need a paper copy',
    paperlessReason5:
      'Email alerts let you know when a new digital statement or document is available.',
    preferencesUpdatedBody:
      'If a document has just been issued it may be the following month before your updated preferences take effect.',
    preferencesUpdatedTitle: 'Your preferences have been updated',
    paperlessInfoTitle: 'Important information',
    paperlessInfoBody1:
      'By tapping the button below, you are agreeing to receive communications from the Bank digitally, including statements. We’ll send you an email whenever a new document is available so it is important to keep your contact details up-to-date. All digital communications will be available to view, print or download from within internet banking and the mobile app. We may continue to send you some statements or documents by post. If you currently receive communications from us in Braille, large text or audio these will stop, however you can change your preferences at any time.',
    paperlessInfoBody2:
      'For joint account holders, you are choosing this option for both of you - so it’s worth checking that the other account holder is happy with this first.',
    preferencesUpdateErrorTitle: 'Sorry, something has gone wrong.',
    preferencesUpdateErrorBody1:
      'Your paper-free preferences have not been updated.',
    preferencesUpdateErrorBody2: 'Please try again later.',
    preferencesAcceptClick: 'Make me paper-free where possible',
    preferencesManageClick: 'Let me choose my paper-free accounts',
    projectionErrorBody:
      "Hmm. Looks like something's gone wrong in the background while loading your Projections. Why not give it another go?",
    projectionButtonTitle: 'Try again',

    preferencesPopupWarningHeaderAuto: 'You haven’t confirmed your changes yet',
    preferencesPopupWarningHeaderManage:
      'You haven’t confirmed your preferences',
    preferencesPopupWarningBodyAuto:
      'Please, review and confirm your preferences before moving on.',
    preferencesPopupWarningBodyManage:
      'You’ve changed your paper-free preferences but haven’t confirmed them yet',
    preferencesContinuePageBtn: 'Review and confirm changes',
    preferencesLeavePageBtn: 'Discard changes',

    accountStatusHeaderContent: "Can't load account details",
    accountStatusBodyContent:
      "Hmm. Looks like something's gone wrong in the background while loading your account details. Let's give it another go.",

    // otp
    authorisationFailedHeader: 'Something’s not right there',
    authorisationFailedBody:
      'The details you’ve entered haven’t been recognised, so for security reasons, you’ve been logged out of B on Web. To continue with your payment, you’ll have to log back in and start again.',

    beneficiaryFailedHeader: 'Check your payee list',
    beneficiaryFailedBody:
      "Hmm. Looks like something may have gone wrong while adding your payee. Before you try and add them again, go back and check your payee list to see if they've been added.",

    //Account picker (Large Customer View)
    accountPickerModalTitle: 'You’ve added all your favourites',
    accountPickerModalContent:
      'You can only set up to 30 favourite accounts. If you’d still like to add this account as a favourite, you can unselect another account by clicking or tapping the star.',
    accountPickerPaymentsChoose:
      'Choose an account to view it’s payment status and history.',
    accountPickerManagePaymentsChoose:
      'Choose an account to view any scheduled payments.',
    accountPickerPageTitle: 'Account',
    accountPickerPageBack: 'Back',
    accountPickerLauncherButton: 'Choose account',
    accountPickerTitle: 'Account',
    accountPickerSelectedButton: 'Change account',
    accountDropDownTitle: 'Account',
    manageAccountPools: {
      accountPoolsTitle: 'Account pools',
      createAccountPool: 'Create account pool',
      noAccountPoolExist:
        'There’s nothing to see yet. Create an account pool if you want to see the combined balances and transactions of more than one business account at a glance.',
      createFirstAccountPool: 'Create first account pool',
    },
  };

  // Address validations. There is a max of 15 so create 15 of these.
  for (var i = 0; i < 15; i++) {
    result['addressPrefix_' + i + 'ValidationMessage'] =
      'Sorry, your flat number must be written using numbers and letters only and no longer than 40 characters.';
    result['addressPrefix_' + i + 'HelpMessage'] =
      'This is the flat number of your house or apartment.';
    result['houseNumber_' + i + 'ValidationMessage'] =
      'Sorry, your house number must be written using numbers and letters only and no longer than 40 characters.';
    result['houseNumber_' + i + 'HelpMessage'] =
      'This is the number of your house or apartment.';
    result['houseName_' + i + 'ValidationMessage'] =
      'Sorry, your house name must be written using numbers and letters only.';
    result['houseName_' + i + 'HelpMessage'] =
      'This is the name of your house or apartment.';
    result['streetName_' + i + 'ValidationMessage'] =
      'Your street name should be written using numbers and letters only and be no longer than 40 characters.';
    result['streetName_' + i + 'HelpMessage'] =
      'Your street name should be written using number and letters only.';

    for (var j = 1; j < 5; j++) {
      result[['addressLine', j, '_', i, 'ValidationMessage'].join('')] =
        'Your address line ' +
        j +
        ' should be written using numbers and letters only and be no longer than 40 characters.';
      result[['addressLine', j, '_', i, 'HelpMessage'].join('')] =
        'Your address line ' +
        j +
        ' should be written using number and letters only.';
    }

    result['city_' + i + 'ValidationMessage'] =
      'Your town should be written using numbers and letters only and no longer than 40 characters.';
    result['city_' + i + 'HelpMessage'] =
      'Please tell us which town or city this address is in.';
    result['county_' + i + 'ValidationMessage'] =
      'Your county should be written using numbers and letters only and no longer than 40 characters.';
    result['county_' + i + 'HelpMessage'] =
      'Please tell us which county this address is in.';
    result['country_' + i + 'ValidationMessage'] =
      'Please select a valid option from the dropdown.';
    result['country_' + i + 'HelpMessage'] =
      'Your current address must be in the UK, but for previous addresses, please tell us which country you lived in.';
    result['dateMoved_' + i + 'ValidationMessage'] =
      "For current addresses, the date you moved in needs to be before today. If it's a previous address, it should be an earlier date than any addresses listed above it.";
    result['dateMoved_' + i + 'HelpMessage'] =
      'Please enter the day month and year you moved to this address.';
    result['postcode_' + i + 'ValidationMessage'] =
      "Please check as this postcode can't be found. Postcodes are normally formatted like this - A12 3BC - if yours still can't be found please call the team at B on " +
      brand.phoneNumber +
      '.';
    result['postcode_' + i + 'HelpMessage'] =
      'You need to supply a valid postcode for any UK address you add. These are normally formatted like this: A12 3BC. If you live at a BFPO address, please call us.';
  }

  return Object.freeze(result);
};
